import { Injectable, NgZone } from '@angular/core';

import Map from 'ol/Map';
import View from 'ol/View';
import {
  Fill,
  Circle as CircleStyle,
  Stroke,
  Style,
  Text,
  Icon,
  RegularShape,
} from 'ol/style';
import { OSM, ImageWMS } from 'ol/source';
import {
  Image as ImageLayer,
  Tile as TileLayer,
  Vector as VectorLayer,
} from 'ol/layer';
import { defaults as defaultcontrol } from 'ol/control';
import VectorSource from 'ol/source/Vector.js';
import { Draw, Modify } from 'ol/interaction';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { LineString, Point, Polygon } from 'ol/geom';
import {
  ip,
  colorcode,
  BURG_LAYER_MIN_ZOOM,
  BURG_LAYER_MAX_ZOOM,
} from '../constant/constant';
import * as turf from '@turf/turf';
import * as booleanvalid from '@turf/boolean-valid';
import { boundingExtent } from 'ol/extent';
import {
  wmsurl,
  workspace,
  layerlist,
  background,
  burgs,
} from '../constant/maplayers';
import {
  projection,
  mapcenter,
  DEFAULT_ZOOM,
  MIN_ZOOM,
  MAX_ZOOM,
  CITY_DEFAULT_ZOOM,
  CITY_MIN_ZOOM,
  CITY_MAX_ZOOM,
} from '../constant/constant';
import { Collection, Feature } from 'ol';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentCreatorModalDetailComponent } from '../pages/content-creator/content-creator-modal-detail/content-creator-modal-detail.component';
import { DataService } from './data.service';
import Crop from 'ol-ext/filter/Crop';
import { MultiPolygon } from 'ol/geom';
import GeoJSON from 'ol/format/GeoJSON';
import { HttpClient } from '@angular/common/http';
import { CoordinatesService } from './coordinates.service';
import { serviceurl } from '../constant/constant';
import { PlayerStoryComponent } from '../modal/player-story/player-story.component';
import { CategoryPlayerViewModalComponent } from '../modal/category-player-view-modal/category-player-view-modal.component';
import { PlayerViewService } from './player-view.service';
import { InfoBarMapViewService } from './info-bar-map-view.service';
import WKT from 'ol/format/WKT';
import { CityMapService } from './city-map.service';
import { AddContentComponent } from '../pages/content-creator/add-content/add-content.component';
import { CityWebDataService } from './city-web-data.service';
import { CurrentUserService } from './current-user.service';
import { ToastService } from './toast.service';
import { Router } from '@angular/router';
import {
  MapCodeData,
  StoryData,
  StoryResponse,
} from '../models/playstory.model';
import { unByKey } from 'ol/Observable';
import { CellDetails, Resources } from '../models/cell-details.model';
import {
  getLength as geodesicLength,
  getArea as geodesicArea,
} from 'ol/sphere';
import { getWidth, getHeight } from 'ol/extent';
import { CropMetrics } from '../models/cropmetricis.model';
import { GameDetailsById } from '../models/game-details.model';
import { ContentData, Pin } from '../pages/content-creator/add-content/models/content.model';

/** What the journal window shows for a move (see PlayerStoryComponent). */
interface JournalContext {
  destination?: string;
  suggestedTitle?: string;
  cityName?: string;
}

@Injectable({
  providedIn: 'root',
})
export class MapService {
  map: Map;
  mapid: string;
  burgLayer: any;
  view: View;
  cityView: View;
  isSideInfo: boolean = true;
  cityvectorSorce: any = null;
  cityVectorLayer: any = null;
  cityFeatureVectorLayer: VectorLayer<VectorSource>;
  userProfileUrl: string = '';
  baselayers: any[];
  map1: Map;
  game_id: string;
  burgs: any = burgs;
  dataObjToUpdate: any;
  cityDrawInteraction: any = null;
  character_id: string;
  layerContentPinLayerInstance: any = null;
  vectorLayer: VectorLayer<VectorSource>;
  layerRedPathHighlightLayer: VectorLayer<VectorSource>;
  layerRedPathHighlightCityLayer: VectorLayer<VectorSource>;

  borderCropFeat: Feature;
  layerlist = layerlist;
  loadDataSubscription: Subscription;
  layerConstLinesLayer: VectorLayer<VectorSource>;
  layerConstCityLinesLayer: VectorLayer<VectorSource>;
  playerStory: { title: string; details: string } = {
    title: '',
    details: '',
  };
  vectorlayerList: any = [];
  universalCords: any;
  layerContentPinLayer: VectorLayer<VectorSource>;
  layerContentCityPinLayer: VectorLayer<VectorSource>;
  handlerAdded: boolean = false;
  contentPinsClickKey: any;
  contentCityPinsClickKey: any;

  // characterDetailsByGame:any
  wmslayerList: any = [];
  startPushing: boolean = false;
  /** Set from the journal: go into the city the move ended on. */
  private pendingEnterCity = false;
  /** A move is in progress (dropped, journal open, or saving): tokens
   *  can't be dragged again until it's saved, cancelled or fails. Without
   *  this a second drag during the slow spot check opened two journals. */
  private moveLocked = false;
  /** Drag tools added on the world map, removed when the map is left
   *  (each visit used to leave one behind). */
  private worldModifyInteraction: any = null;
  private worldDragHandler: any = null;
  private partyModifyInteraction: any = null;
  continusCordArray: any = [];
  mapCodeDataContainer: any;
  cityStaticFeatureLayer: VectorLayer<VectorSource>;
  continusCityCordArray: any = [];
  playerCoordinates: any;
  arrayOfLayerNames: any = [
    'foglayer',
    'border',
    'rivers',
    'routes',
    'miltary',
    'grid',
    'cells',
  ];
  viewparam: any;
  cityCode: number = null;
  handleMapClickHandler: any;
  handleContentClickHandler: any;
  cityContentCreatorData: any;
  cityContentPlayersData: any;
  coordsArrOfPointsUserCity: any;
  coordsArrOfPointsMapCodeCityCodeCity: any;
  contentCreatorData: any;
  mapService: any;
  user_id: any;
  getpartybygame: any;
  Id: any;
  modifyInteraction: any;
  playerFeature: any;
  playerCurrentLocationCords: any;
  navigateToCityFlag: boolean = true;
  mainDrawInteraction: any;
  private lineFeature: Feature | null = null; // Define the line feature
  private draggedFeature: Feature | null = null;
  unbindSingleClickKey: any;
  birthLocationLayer: VectorLayer<VectorSource>;
  playerToGameLocationLayer: VectorLayer<VectorSource>;
  sharedLocationLayer: VectorLayer<VectorSource>;
  playerModifyInteraction: any;
  cityLandCoordinates: any;
  cityDrawStartHandler: any;
  cityDrawEndHandler: any;
  game_system: string | null = null;
  map_genre: string | null = null;
  private mapListSubject = new BehaviorSubject<any[]>(null);
  public mapList$ = this.mapListSubject.asObservable();
  private singlePointLayer: VectorLayer<VectorSource> | null = null;

  // The image feature being dragged
  constructor(
    private DataService: DataService,
    private http: HttpClient,
    private coordinateService: CoordinatesService,
    private modalService: NgbModal,
    private playerViewService: PlayerViewService,
    private infoBarService: InfoBarMapViewService,
    private cityMapService: CityMapService,
    private cityDataService: CityWebDataService,
    private currentUserService: CurrentUserService,
    private toasterService: ToastService,
    private router: Router,
  ) {
    //
    this.initializeMap();
    this.cityIntializeMap();
  }

  public getMapList(
    userId: string | number = this.user_id,
    force: boolean = false,
  ): void {
    if (!this.mapListSubject.value || force) {
      this.DataService.Getmaplist(userId).subscribe({
        next: (data: any) => {

          this.mapListSubject.next(data.res);
        },
        error: (err) => {
          console.error('Error fetching map list:', err);
          this.mapListSubject.next([]);
        },
      });
    }
  }
  /**
   * Initializes the map with OSM and vector layers.
   */
  public initializeMap(): void {
    this.viewparam = 'mapcode:' + this.mapid;
    window.dispatchEvent(new Event('resize'));
    // Create a new OSM tile layer
    const osmLayer = new TileLayer({
      source: new OSM(),
    });

    // Create a new vector layer
    this.vectorLayer = new VectorLayer({
      zIndex: 202,
      source: new VectorSource(),
    });

    // Initialize the map with layers and view settings
    this.view = new View({
      projection: projection,
      center: mapcenter,
      zoom: DEFAULT_ZOOM,
      minZoom: MIN_ZOOM,
      maxZoom: MAX_ZOOM,
    });
    const backdrop = background;

    this.map = new Map({
      layers: [backdrop, this.vectorLayer],
      view: this.view,
      controls: defaultcontrol({ zoom: false }),
    });
    this.unbindSingleClickKey = this.map.on(
      'singleclick',
      this.handleMapClickHandlerSingleClick.bind(this),
    );
    this.currentUserService.currentUser.subscribe((data) => {
      this.user_id = data?.id;
    });
  }
  handleMapClickHandlerSingleClick = (evt: any): void => {
    const viewResolution = this.view.getResolution();
    this.universalCords = evt.coordinate;

    const findIndex = this.layerlist.findIndex((lyr) => lyr.name === 'cells');
    const url = this.wmslayerList[findIndex]
      .getSource()
      .getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        this.view.getProjection(),
        {
          INFO_FORMAT: 'application/json',
          FEATURE_COUNT: 1,
          VIEWPARAMS: `mapcode:${this.mapCodeDataContainer.map_id}`,
        },
      );
    this.DataService.getCustomCellData({
      longitude: evt.coordinate[0],
      latitude: evt.coordinate[1],
      map_code: this.mapCodeDataContainer.map_id,
    }).subscribe((data: CellDetails) => {
      const resourceObj = this.processResourceObjectToPass(data);
      if (data && data.burg_id) {
        this.infoBarService.setNewInfo({
          resource_values: resourceObj,
          burg_values: data.burgs_data,
        });
        // this.coordinateService.setNewCellResourceDetails(data);
      } else {
        this.infoBarService.setNewInfo({
          resource_values: resourceObj,
          burg_values: null,
        });
      }
    });

    let feature: any;

    const pixel = evt.pixel;
    const coordinate = this.map.getCoordinateFromPixel(pixel);
    this.coordinateService.setNewPlayerOuterCoordinates(coordinate);

    const tolerance = this.map.getView().getResolution() * 15;
    const extent = boundingExtent([
      [coordinate[0] - tolerance, coordinate[1] - tolerance],
      [coordinate[0] + tolerance, coordinate[1] + tolerance],
    ]);

    this.burgLayer.getSource().forEachFeatureInExtent(extent, (feat) => {
      if (feat.getProperties()['burg_id']) {
        feature = feat;
      }
    });

    if (feature && feature.getProperties()['burg_id']) {
      this.cityCode = parseInt(feature.getProperties()['burg_id']);
      const backRoute = this.mapCodeDataContainer.cityBackNavigate;

      let geometry: any;
      geometry = feature.getGeometry()?.getCoordinates();
      this.cityMapService.setCityMapVisiblity({
        visible: true,
        code: this.cityCode,
      });

      if (this.navigateToCityFlag) {
        const featureExtent = feature.getGeometry().getExtent();
        localStorage.setItem('lastCityVisited', JSON.stringify(featureExtent));
        this.router.navigate(
          [
            'city-map-view',
            feature.getProperties()['burg_id'],
            this.mapCodeDataContainer.map_id,
            this.mapCodeDataContainer.game_id ?? 'null',
            this.mapCodeDataContainer.character_id ?? 'null',
          ],
          {
            queryParams: {
              token: this.userProfileUrl,
              isLoadToken: false,
              isCityVisited: true,
              game_system: this.game_system || null,
              backRoute,
            },
          },
        );
      }
    }
  };

  processResourceObjectToPass(data: CellDetails) {
    // Build the resource object for the CELL DETAILS panel (no burg info)
    const resourceObj = {
      map_name: data.map_name,
      culture: data.culture,
      religion: data.religion,
      state: data.state,
      province: data.province,
      biome: data.biome,
      elevation: data.elevation,
      population: data.population,
      depth: data.depth,
      basic_resources: data.resources?.basic || [],
      bonus_resources: data.resources?.bonus || [],
      mineral_resources: data.resources?.mineral || [],
      farm_resources: data.resources?.farmed || [],
      special_resources: data.resources?.special || [],
    };
    // You can now use resourceObj as needed (e.g., pass to info bar, etc.)
    return resourceObj;
  }

  cityIntializeMap() {
    this.map1 = new Map({
      layers: [],
      view: (this.cityView = new View({
        projection: 'EPSG:3857',
        zoom: CITY_DEFAULT_ZOOM,
        minZoom: CITY_MIN_ZOOM,
        maxZoom: CITY_MAX_ZOOM,
        // constrainResolution: true,
      })),
      controls: defaultcontrol({
        attribution: false,
        zoom: false,
      }),
    });
  }
  loaddata(layer) {
    const properties = layer.getProperties();
    this.loadDataSubscription = this.DataService.getMapData(
      properties.servicename,
      this.mapid,
    ).subscribe((data: any) => {
      var features = [];
      const format = new WKT();
      data.res.forEach((feat) => {
        var feature = format.readFeature(
          feat.geom.split(';')[1].replace(' ', ''),
        );
        feature.setProperties(feat);
        features.push(feature);
      });
      layer.getSource().addFeatures(features);
    });
  }

  citydataload(
    cityid: any,
    mapcode: any,
    isLoadToken: boolean,
    isPlaceToken: string | boolean,
    isGame: boolean,
    common_id?: any,
    isMovable?: boolean,
    isAskTokenToPlace?: boolean,
    game_details?: any,
  ) {
    this.cityLandCoordinates = [];
    this.cityCode = cityid;

    this.DataService.getCityData(mapcode, cityid).subscribe((data: any) => {
      if (data.res) {
        let citydata = data.res;
        let index = 0;
        index = citydata.features?.findIndex((feat) => feat.id == 'earth');
        if (index > -1) {
          // Do something with the 'earth' feature
          this.cityLandCoordinates = citydata.features[index].coordinates[0];
        }

        this.loadcitymap(citydata);
        this.initServiceContext(common_id, mapcode, isGame);

        if (!isGame && isLoadToken) {
          this.handlePlayerCityLogic(
            common_id,
            mapcode,
            cityid,
            isMovable,
            isAskTokenToPlace,
            isPlaceToken
          );
        } else if (isGame && !isLoadToken) {
          this.addCityStaticPoint(game_details.spawn_location?.split(',')?.map((item: any) => item.trim()), game_details.partytoken);
        } else if (isLoadToken && isGame) {
          this.handleGameMasterCityLogic(
            common_id,
            mapcode,
            cityid,
            isAskTokenToPlace,
            isPlaceToken
          );
        }
      }
    });
  }

  private initServiceContext(common_id: any, mapcode: any, isGame: boolean) {
    // DO NOT MOVE — service-wide dependency
    this.Id = parseInt(common_id);
    this.mapCodeDataContainer.map_id = mapcode;
    this.mapCodeDataContainer.type = isGame ? 'Master' : 'Player';
    this.getpartybygame = isGame ? 'gamemaster' : 'player';
  }

  private handlePlayerCityLogic(
    common_id: any,
    mapcode: any,
    cityid: any,
    isMovable?: boolean,
    isAskTokenToPlace?: boolean,
    isPlaceToken?: any
  ) {
    this.getPlayerAllHistoryData(common_id, mapcode);

    this.cityDataService
      .getCityHistoryData(common_id, mapcode, cityid)
      .subscribe((historyRecords: any) => {
        const history = historyRecords.res || [];
        if (history.length > 0) {
          this.addCityConstantLine(history, true);
          this.coordinateService.setNewCityHistoryRecords(history);
          const lastLocation = history[history.length - 1]?.current_location;

          if (isMovable) {
            if (isAskTokenToPlace) {
              this.addCityInteraction(null, true);
            } else {
              this.addCityInteraction(
                lastLocation,
                false
              );
            }
          } else {
            this.addCityStaticPoint(
              lastLocation?.split(','),
              true
            );
          }
        } else {
          this.coordinateService.setNewCityHistoryRecords(null);

          if (isMovable) {
            this.addCityInteraction(null, true);
          } else {
            this.addCityStaticPoint(isPlaceToken, isPlaceToken);
          }
        }
      });
  }
  private handleGameMasterCityLogic(
    common_id: any,
    mapcode: any,
    cityid: any,
    isAskTokenToPlace?: boolean,
    isPlaceToken?: any
  ) {
    this.getAllGameMasterHistoryData(common_id, mapcode);

    this.cityDataService
      .getCitylocationhistoryGame(
        this.character_id === undefined ||
          this.character_id === '' ||
          this.character_id === null
          ? this.Id
          : this.character_id,
        mapcode,
        cityid
      )
      .subscribe((historyRecords: any) => {
        const history = historyRecords.party_location_history || [];
        if (history.length > 0) {
          this.addCityConstantLine(
            history,
            true
          );
          this.coordinateService.setNewCityHistoryRecords(
            history
          );
          const lastLocation = history[history.length - 1]?.current_location;

          if (isAskTokenToPlace) {
            this.addCityInteraction(null, true);
          } else {
            this.addCityInteraction(
              lastLocation,
              false
            );
          }
        } else {
          this.coordinateService.setNewCityHistoryRecords(null);

          if (history.length == 0) {
            this.addCityInteraction(null, true);
          } else {
            this.addCityInteraction(isPlaceToken, false);
          }
        }
      });
  }

  getPlayerAllHistoryData(common_id: string, mapcode: string) {
    this.DataService.getHistoryDetailByCharacterId(
      common_id,
      mapcode,
    ).subscribe({
      next: (data: any) => {
        if (data.length > 0) {
          this.coordinateService.setNewHistoryRecords(data);
        } else {
          this.coordinateService.setNewHistoryRecords(null);
        }
      },
    });
  }

  getAllGameMasterHistoryData(common_id: string, mapcode: string) {
    this.DataService.partylocationhistory(common_id, mapcode).subscribe({
      next: (data: any) => {
        if (data?.length > 0) {
          this.coordinateService.setNewHistoryRecords(data);
        } else {
          this.coordinateService.setNewHistoryRecords(null);
        }
      },
    });
  }

  addCityInteraction(geo, isTravel) {
    if (!this.cityFeatureVectorLayer) {
      this.cityFeatureVectorLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 99,
      });
      this.map1.addLayer(this.cityFeatureVectorLayer);
    }
    let modify = new Modify({
      source: this.cityFeatureVectorLayer.getSource(),
    });
    this.map1.addInteraction(modify);
    if (geo) {
      var feature = new Feature({
        geometry: new Point(geo.split(',')),
      });
      feature.setStyle(
        new Style({
          image: new Icon({
            src: ip + this.userProfileUrl, // Replace with the drawing icon path
            scale: 0.4,
          }),
        }),
      );

      this.map1.getView().fit(feature.getGeometry(), {
        maxZoom: 18,
        duration: 500,
      });

      const coords = (feature.getGeometry() as Point).getCoordinates() as [
        number,
        number,
      ];
      const isInside = this.isPointInsidePolygon(
        coords,
        this.cityLandCoordinates,
      );
      this.coordinateService.setAtCityBoundary(!isInside);

      this.playerFeature = feature;
      this.playerCurrentLocationCords = geo.split(',');

      this.cityFeatureVectorLayer.getSource().addFeature(feature);
    } else if (!geo && isTravel) {
      this.toasterService.showNote(
        'Place your token in the blue outskirts of the city to enter it.',
        'note',
      );

      this.coordinateService.setAtCityBoundary(false);

      // 🧹 Step 1: Robust clear with logging and force re-render
      const citySource = this.cityFeatureVectorLayer.getSource();
      if (citySource) {
        citySource.clear();
        citySource.changed(); // Trigger layer update
        this.map1.render(); // Force map re-render
      } else {
        console.error('citySource is null - Initializing fallback...');
        // Fallback: Recreate source if null
        this.cityFeatureVectorLayer.setSource(new VectorSource());
      }

      // 🚫 Remove existing draw interaction to prevent multiples
      if (this.cityDrawInteraction) {
        this.map1.removeInteraction(this.cityDrawInteraction);
        // Unbind listeners to avoid accumulation
        this.cityDrawInteraction.un('drawstart');
        this.cityDrawInteraction.un('drawend');
        this.cityDrawInteraction = null;
      }

      // 🧭 Step 2: Create new draw interaction
      const drawStyle = new Style({
        image: new Icon({
          src: ip + this.userProfileUrl,
          scale: 0.4,
        }),
      });

      this.cityDrawInteraction = new Draw({
        source: citySource,
        type: 'Point',
        style: drawStyle,
      });

      // 🎨 Step 3: Drawstart listener (will be attached once)
      const drawStartHandler = (event) => {
        const feature = event.feature;
        feature.setStyle(
          new Style({
            image: new Icon({
              src: ip + this.userProfileUrl,
              scale: 0.5,
            }),
          }),
        );
      };
      this.cityDrawInteraction.on('drawstart', drawStartHandler);

      // 📍 Step 4: Drawend handler
      const drawEndHandler = (event) => {
        const geometry = event.feature.getGeometry() as Point;
        const drawnCoordinates: [number, number] =
          geometry.getCoordinates() as [number, number];
        const isInside = this.isPointInsidePolygon(
          drawnCoordinates,
          this.cityLandCoordinates,
        );
        if (isInside) {
          // ❌ Invalid point
          this.coordinateService.setNewCoordinates(null);
          this.playerFeature = null;

          this.toasterService.showNote(
            'Place the token in the blue outskirts, not inside the city.',
            'danger',
          );

          // 🧹 Remove invalid feature with logging
          if (citySource && event.feature) {
            citySource.removeFeature(event.feature);
          }
          citySource.changed(); // Trigger update
          this.map1.render(); // Force visual refresh

          // ♻️ Fallback: If features still persist, remove/re-add layer
          if (true) {
            console.warn(
              'Features persist after clear/remove - Recreating layer',
            );
            this.map1.removeLayer(this.cityFeatureVectorLayer);
            this.cityFeatureVectorLayer.setSource(new VectorSource());
            this.map1.addLayer(this.cityFeatureVectorLayer);
          }

          // Create fresh interaction for retry
          this.cityDrawInteraction.un('drawstart', drawStartHandler);
          this.cityDrawInteraction.un('drawend', drawEndHandler);
          this.map1.removeInteraction(this.cityDrawInteraction);
          this.cityDrawInteraction = new Draw({
            source: this.cityFeatureVectorLayer.getSource(),
            type: 'Point',
            style: drawStyle,
          });
          this.cityDrawInteraction.on('drawstart', drawStartHandler);
          this.cityDrawInteraction.on('drawend', drawEndHandler);
          this.map1.addInteraction(this.cityDrawInteraction);
        } else {
          // ✅ Valid point
          this.coordinateService.setAtCityBoundary(true); // Fixed: Set to true for inside
          this.coordinateService.setNewCoordinates(drawnCoordinates);
          this.continusCityCordArray.push(drawnCoordinates);
          this.playerFeature = event.feature;

          // Unbind and remove interaction
          this.cityDrawInteraction.un('drawstart', drawStartHandler);
          this.cityDrawInteraction.un('drawend', drawEndHandler);
          this.map1.removeInteraction(this.cityDrawInteraction);
          this.cityDrawInteraction = null;

          // Force re-render after add
          citySource.changed();
          this.map1.render();
          this.detachModifyHandlers(modify);
          this.map1.removeInteraction(modify);
          modify = new Modify({
            source: this.cityFeatureVectorLayer.getSource(),
          });
          this.attachModifyHandlers(modify);
          this.map1.addInteraction(modify);

          this.playStoryInsert(
            this.mapCodeDataContainer,
            this.continusCityCordArray[this.continusCityCordArray.length - 1],
            this.cityCode,
            false,
            null,
            true,
          );
        }
      };
      this.cityDrawInteraction.on('drawend', drawEndHandler);

      // 🚀 Step 5: Add to map
      this.map1.addInteraction(this.cityDrawInteraction);
    }

    this.map1.on('pointerdrag', (e) => {
      if (this.startPushing) this.continusCityCordArray.push(e.coordinate);
    });

    modify.on('modifystart', (e) => {
      e.features.forEach((f: any) => {
        const starCoords = f.getGeometry().getCoordinates() as [string, string];
        const numericCoords: [number, number] = [
          parseFloat(starCoords[0]),
          parseFloat(starCoords[1]),
        ];

        this.continusCityCordArray.push(numericCoords);
      });

      this.startPushing = true;
    });
    modify.on('modifyend', (e) => {
      this.startPushing = false;

      const modifiedFeature = e.features.item(0);
      const geometry: any = modifiedFeature.getGeometry();
      const coords = geometry.getCoordinates();

      const isInside = this.isPointInsidePolygon(
        coords,
        this.cityLandCoordinates,
      );
      if (!isInside) {
        this.coordinateService.setAtCityBoundary(true);
      } else {
        this.coordinateService.setAtCityBoundary(false);
      }

      // save where the token actually landed (it used the last drag point)
      this.continusCityCordArray.push(coords);
      this.playStoryInsert(
        this.mapCodeDataContainer,
        coords,
        this.cityCode,
      );
    });
  }

  private detachModifyHandlers(modify: any) {
    modify.un('modifystart', this.onModifyStart);
    modify.un('modifyend', this.onModifyEnd);
  }

  /** -----------------------------------
   *  MAIN ENTRY — Initialize Draw Flow
   * ----------------------------------- */
  initCityDraw(reIntialize: boolean) {
    this.destroyCityDraw();
    if (reIntialize)
      this.toasterService.showNote(
        'Place the token in the blue outskirts to start.',
        'danger',
      ); // Always clear old draw
    const drawStyle = this.getDrawStyle();

    this.cityDrawInteraction = new Draw({
      source: this.cityFeatureVectorLayer.getSource(),
      type: 'Point',
      style: drawStyle,
    });

    this.cityDrawStartHandler = this.handleDrawStart.bind(this);
    this.cityDrawEndHandler = this.handleDrawEnd.bind(this);

    this.cityDrawInteraction.on('drawstart', this.cityDrawStartHandler);
    this.cityDrawInteraction.on('drawend', this.cityDrawEndHandler);

    this.map1.addInteraction(this.cityDrawInteraction);
  }

  /** -----------------------------------
   * Destroy Draw Interaction Completely
   * ----------------------------------- */
  destroyCityDraw() {
    if (!this.cityDrawInteraction) return;

    this.cityDrawInteraction.un('drawstart', this.cityDrawStartHandler);
    this.cityDrawInteraction.un('drawend', this.cityDrawEndHandler);

    this.map1.removeInteraction(this.cityDrawInteraction);
    this.cityDrawInteraction = null;
    this.map1.render();
  }

  cleanupInvalidPlacement(eventFeature?: Feature) {
    const source = this.cityFeatureVectorLayer.getSource();
    this.continusCityCordArray = [];

    // 1. Clear service values
    this.coordinateService.setNewCoordinates(null);
    this.coordinateService.setAtCityBoundary(false);

    this.playerFeature = null;

    // 2. Remove the feature if provided
    if (source && eventFeature) {
      source.removeFeature(eventFeature);
    }

    // 3. Trigger visual update
    source.changed();
    this.map1.render();

    // 4. Reset the feature layer if OL caching misbehaves
    this.map1.removeLayer(this.cityFeatureVectorLayer);
    this.cityFeatureVectorLayer.setSource(new VectorSource());
    this.map1.addLayer(this.cityFeatureVectorLayer);

    // 5. Recreate fresh draw interaction
    this.destroyCityDraw(); // remove old interaction cleanly
  }

  /** -----------------------------------
   * Style Generator
   * ----------------------------------- */
  getDrawStyle(scale = 0.4) {
    return new Style({
      image: new Icon({
        src: ip + this.userProfileUrl,
        scale,
      }),
    });
  }

  /** -----------------------------------
   * DRAW START HANDLER
   * ----------------------------------- */
  handleDrawStart(event) {
    event.feature.setStyle(this.getDrawStyle(0.5));
  }

  /** -----------------------------------
   * DRAW END HANDLER
   * ----------------------------------- */
  handleDrawEnd(event) {
    const pointGeom = event.feature.getGeometry() as Point;
    const coords = pointGeom.getCoordinates() as [number, number];

    const isInside = this.isPointInsidePolygon(
      coords,
      this.cityLandCoordinates,
    );

    if (isInside) {
      this.handleInvalidPoint(event);
    } else {
      this.handleValidPoint(event, coords);
    }
  }

  /** -----------------------------------
   * VALID POINT SELECTED (Outside City)
   * ----------------------------------- */
  handleValidPoint(event, coords) {
    this.coordinateService.setAtCityBoundary(true);
    this.coordinateService.setNewCoordinates(coords);

    this.continusCityCordArray.push(coords);
    this.playerFeature = event.feature;

    const source = this.cityFeatureVectorLayer.getSource();
    source.changed();
    this.map1.render();

    this.destroyCityDraw(); // remove draw mode

    // Refresh modify interaction
    this.map1.removeInteraction(this.modifyInteraction);
    this.modifyInteraction = new Modify({ source });
    this.attachModifyHandlers(this.modifyInteraction);
    this.map1.addInteraction(this.modifyInteraction);

    // Insert story call
    this.playStoryInsert(
      this.mapCodeDataContainer,
      coords,
      this.cityCode,
      false,
      null,
      true,
    );
  }

  /** -----------------------------------
   * INVALID POINT SELECTED (Inside City)
   * ----------------------------------- */
  handleInvalidPoint(event) {
    this.coordinateService.setNewCoordinates(null);
    this.playerFeature = null;

    this.toasterService.showNote(
      'Place the token in the blue outskirts, not inside the city.',
      'danger',
    );

    const source = this.cityFeatureVectorLayer.getSource();
    source.removeFeature(event.feature);
    source.changed();
    this.map1.render();

    this.rebuildLayerIfNeeded(source);
    this.resetInteractionsAfterInvalid();
  }

  /** -----------------------------------
   * Rebuild Layer If Features Misbehaving
   * ----------------------------------- */
  rebuildLayerIfNeeded(source) {
    if (true) {
      this.map1.removeLayer(this.cityFeatureVectorLayer);
      this.cityFeatureVectorLayer.setSource(new VectorSource());
      this.map1.addLayer(this.cityFeatureVectorLayer);
    }
  }

  /** -----------------------------------
   * Reset Draw Interaction After Invalid
   * ----------------------------------- */
  resetInteractionsAfterInvalid() {
    this.destroyCityDraw();
    this.initCityDraw(false); // restart clean draw mode
  }

  private onModifyStart = (e: any) => {
    e.features.forEach((f: any) => {
      const starCoords = f.getGeometry().getCoordinates() as [string, string];
      const numericCoords: [number, number] = [
        parseFloat(starCoords[0]),
        parseFloat(starCoords[1]),
      ];

      this.continusCityCordArray.push(numericCoords);
    });

    this.startPushing = true;
  };

  private onModifyEnd = (e: any) => {
    this.startPushing = false;

    const modifiedFeature = e.features.item(0);
    const geometry: any = modifiedFeature.getGeometry();
    const coords = geometry.getCoordinates();

    const isInside = this.isPointInsidePolygon(
      coords,
      this.cityLandCoordinates,
    );
    if (!isInside) {
      this.coordinateService.setAtCityBoundary(true);
    } else {
      this.coordinateService.setAtCityBoundary(false);
    }

    // save where the token actually landed (it used the last drag point)
    this.continusCityCordArray.push(coords);
    this.playStoryInsert(
      this.mapCodeDataContainer,
      coords,
      this.cityCode,
    );
  };

  private attachModifyHandlers(modify: any) {
    modify.on('modifystart', this.onModifyStart);
    modify.on('modifyend', this.onModifyEnd);
  }

  isPointInsidePolygon(
    pointCoord: [number, number],
    polygonCoords: [number, number][],
  ): boolean {
    if (!pointCoord || !polygonCoords) {
      return false;
    }
    if (polygonCoords.length < 3) {
      return false;
    }

    // Close the polygon if not closed
    const first = polygonCoords[0];
    const last = polygonCoords[polygonCoords.length - 1];
    if (first[0] !== last[0] || first[1] !== last[1]) {
      polygonCoords = [...polygonCoords, first];
    }

    const polygon = new Polygon([polygonCoords]);
    return polygon.intersectsCoordinate(pointCoord);
  }

  removeCityLayer() {
    this.moveLocked = false; // leaving the city ends any open move
    if (this.map1) {
      this.cityvectorSorce?.clear();
      if (this.cityFeatureVectorLayer) {
        this.cityFeatureVectorLayer.getSource().clear();
        this.map1.removeLayer(this.cityFeatureVectorLayer);
        this.cityFeatureVectorLayer = null;
      }
      if (this.cityDrawInteraction) {
        this.map1.removeInteraction(this.cityDrawInteraction);
      }

      if (this.layerContentCityPinLayer) {
        this.layerContentCityPinLayer.getSource().clear();
        this.map1.removeLayer(this.layerContentCityPinLayer);
        this.layerContentCityPinLayer = null;
      }

      if (this.layerRedPathHighlightCityLayer) {
        this.layerRedPathHighlightCityLayer.getSource().clear();
        this.map1.removeLayer(this.layerRedPathHighlightCityLayer);
        this.layerRedPathHighlightCityLayer = null;
      }
      if (this.cityStaticFeatureLayer) {
        this.map1.removeLayer(this.cityStaticFeatureLayer);
        this.cityStaticFeatureLayer = null;
      }
      if (this.layerConstCityLinesLayer) {
        this.layerConstCityLinesLayer.getSource().clear();
      }
      this.game_id = null;
      this.character_id = null;
      this.map_genre = null;
      this.navigateToCityFlag = true;
      this.cityDrawInteraction = null;
      if (this.handleContentClickHandler) {
        this.map1.un('singleclick', this.handleContentClickHandler);
        this.map1.un('pointerdrag', this.handleContentClickHandler);
      }
      if (this.handleMapClickHandler) {
        this.map1.un('singleclick', this.handleMapClickHandler);
      }
    }
    this.map1?.setTarget(null);
    this.cityMapService.setCityMapVisiblity({ visible: false, code: null });
  }

  loadcitymap(citydata?) {
    if (!this.map1) {
      this.map1 = new Map({
        target: 'map1',
        layers: [],
        view: (this.cityView = new View({
          projection: 'EPSG:3857',
          zoom: 18,
          minZoom: 17,
          maxZoom: 20,
          // constrainResolution: true,
        })),
        controls: defaultcontrol({
          attribution: false,
          // zoom: false,
        }),
      });
    }
    if (!this.cityVectorLayer) {
      this.cityvectorSorce = new VectorSource();
      this.cityVectorLayer = new VectorLayer({
        source: this.cityvectorSorce,
        style: (e, resolution) => {
          return this.cityFeatureStyle(
            e,
            resolution,
            this.map1.getView().getZoom(),
          );
        },
      });
      this.map1.addLayer(this.cityVectorLayer);
    }
    this.map1.on('singleclick', (evt) => {
      var viewResolution = this.cityView.getResolution();
      var url = this.wmslayerList[11]?.getSource();
    });
    var features = [];
    /*citydata.forEach(feat => {
    const format = new WKT();
    var feature = format.readFeature(feat.geom.split(';')[1].replace(' ', ''))
    feature.setProperties(feat)
    features.push(feature)
  })
  cityvectorSorce.addFeatures(features)*/

    const newfeatures = [];

    citydata.features.forEach((element) => {
      if (element.type == 'Feature' && element.id == 'values') {
      } else if (element.type == 'Feature' && element.id != 'values') {
        const feature = new GeoJSON().readFeature(element);

        newfeatures.push(feature);
      } else if (element.type == 'GeometryCollection') {
        //newfeatures.push(new GeoJSON().readFeature(element))
        element.geometries.forEach((newgeom, index) => {
          const cords = newgeom.coordinates;
          if (newgeom.type == 'Polygon') {
            if (cords[0][0] !== cords[0][cords[0].length - 1]) {
              cords[0].push(newgeom.coordinates[0][0]);
            }
          }
          if (element.id == 'walls') {
            cords[0].forEach((crdswall, idx) => {
              const obj2 = {
                type: 'Feature',
                id: 'wallspoint.' + idx,
                properties: crdswall,
                geometry: {
                  type: 'Point',
                  coordinates: crdswall,
                },
              };
              const newobj2 = new GeoJSON().readFeature(obj2);

              newfeatures.push(newobj2);
            });
          }
          const obj = {
            type: 'Feature',
            id: element.id + '.' + index,
            properties: newgeom,
            geometry: {
              type: newgeom.type,
              coordinates: cords,
            },
          };
          var feature = turf.feature(obj.geometry, obj.properties);
          if (element.id == 'districts') {
          }
          const newobj = new GeoJSON().readFeature(obj);

          newfeatures.push(newobj);
        });
      } else {
        if (element.coordinates && element.coordinates.length > 0) {
          const obj = {
            type: 'Feature',
            id: element.id,
            properties: { element },
            geometry: {
              type: element.type,
              coordinates: element.coordinates,
            },
          };
          newfeatures.push(new GeoJSON().readFeature(obj));
        }
      }
    });

    this.cityvectorSorce.clear();
    this.cityvectorSorce.addFeatures(newfeatures);
    this.map1.getView().fit(this.cityvectorSorce.getExtent());
  }

  cityFeatureStyle(feature, resolution, zoom) {
    const properties = feature.getProperties();
    const nfeautreid = feature.id_.split('.')[0];
    var style;
    if (feature.id_ == 'water') {
      style = [
        new Style({
          fill: new Fill({
            color: '#85BCB2',
          }),
        }),
      ];
    } else if (nfeautreid == 'buildings') {
      style = [
        new Style({
          fill: new Fill({
            color: '#D6A36E',
          }),
          stroke: new Stroke({
            color: '#4C5950',
            width: 2,
          }),
        }),
      ];
    } else if (nfeautreid == 'fields') {
      const cnv = document.createElement('canvas');
      const ctx = cnv.getContext('2d');
      var img = new Image();
      img.src = 'assets/green.png'; // your image here
      var pattern = ctx.createPattern(img, 'repeat');

      style = [
        new Style({
          fill: new Fill({
            // color:pattern
            color: '#99AA77',
          }),
          stroke: new Stroke({
            color: '#99AA77',
            width: 1,
          }),
        }),
      ];
    } else if (nfeautreid == 'squares') {
      style = [
        new Style({
          fill: new Fill({
            color: '#6B645F',
          }),
          stroke: new Stroke({
            color: '#99AA77',
            width: 1,
          }),
        }),
      ];
    } else if (nfeautreid == 'earth') {
      style = [
        new Style({
          fill: new Fill({
            color: '#FFF2C8',
          }),
          stroke: new Stroke({
            color: '#99AA77',
            width: 1,
          }),
        }),
      ];
    } else if (nfeautreid == 'trees') {
      var size = 1;
      if (zoom < 12) {
        size = 1;
      } else if (zoom > 12 && zoom <= 14) {
        size = 2;
      } else {
        size = 5;
      }
      style = new Style({
        image: new CircleStyle({
          radius: zoom > 15 ? 5 : 2,
          fill: new Fill({
            color: '#667755',
          }),
        }),
      });
    } else if (nfeautreid == 'Walls' || nfeautreid == 'walls') {
      const geometry = feature.getGeometry();
      const coordinates = geometry.getCoordinates();
      // Initialize styles with line style
      const pointFeaturesstyle = []; // To store the point features

      // Loop through coordinates and create a point feature for each
      coordinates.forEach((coord) => {
        const pointStyle = new Style({
          geometry: new Point(coord), // Attach the point geometry to the style
          image: new CircleStyle({
            radius: 15, // Size of the circle
            fill: new Fill({ color: 'red' }), // Color of the circle
          }),
        });

        pointFeaturesstyle.push(pointStyle); // Add the point feature to the list
      });
      style = [
        new Style({
          stroke: new Stroke({
            color: '#606661',
            width: feature.getProperties().width,
          }),
        }),
        ...pointFeaturesstyle,
      ];
    } else if (nfeautreid == 'wallspoint') {
      const geometry = feature.getGeometry();
      const coordinates = geometry.getCoordinates();

      style = new Style({
        image: new RegularShape({
          points: 4, // 4 points = square or rectangle
          radius: 10, // Controls the size
          angle: 0, // 0° means upright, adjust for rotation
          fill: new Fill({ color: '#606661' }), // Red rectangle
          stroke: new Stroke({ color: '#606661', width: 2 }), // Black border
        }),
      });
    } else if (nfeautreid == 'roads') {
      var size = 10;
      if (resolution <= 0.14929107086948487) {
        size = feature.getProperties().width * 3;
      } else if (
        resolution <= 0.2985821417389697 &&
        resolution > 0.14929107086948487
      ) {
        size = feature.getProperties().width * 2;
      } else if (
        resolution <= 0.5971642834779 &&
        resolution > 0.14929107086948487
      ) {
        size = feature.getProperties().width;
      }

      const offsetGeometry = (geometry, offset) => {
        return new LineString(
          geometry.getCoordinates().map(([x, y]) => [x, y + offset]), // Offset vertically
        );
      };
      const offsetStyle = new Style({
        geometry: (feature) => offsetGeometry(feature.getGeometry(), 0.5), // Offset by 0.5 units
        stroke: new Stroke({
          color: '#FFF2C8', // Offset border color
          width: size, // Wider stroke for border effect
        }),
      });
      style = [
        // new Style({
        //   fill: new Fill({
        //     color: '#ccc5b8',
        //   }),
        // }),
        new Style({
          // fill: new Fill({
          //   color: '#ccc5b8',
          // }),
          stroke: new Stroke({
            color: '#FFF2C8',
            width: 10,
          }),
        }),
        offsetStyle,
      ];
    } else if (nfeautreid == 'rivers') {
      var size = 37;
      if (resolution <= 0.14929107086948487) {
        size = feature.getProperties().width * 3;
      } else if (
        resolution <= 0.2985821417389697 &&
        resolution > 0.14929107086948487
      ) {
        size = feature.getProperties().width * 2;
      } else if (
        resolution <= 0.5971642834779 &&
        resolution > 0.14929107086948487
      ) {
        size = feature.getProperties().width;
      }

      style = [
        new Style({
          fill: new Fill({
            color: '#85BCB2',
          }),
          stroke: new Stroke({
            color: '#85BCB2',
            width: size,
            //width:25,
          }),
        }),
      ];
    } else if (properties.type == 'fields') {
      style = new Style({
        fill: new Fill({
          color: '#ccc5b8',
        }),
        stroke: new Stroke({
          color: '#1a1917',
          width: 1,
        }),
      });
    } else if (nfeautreid == 'districts') {
      const indexdistric = feature.id_.split('.')[1];

      style = new Style({
        fill: new Fill({
          color: colorcode[indexdistric],
          // opacity: 0.2
        }),
        stroke: new Stroke({
          color: colorcode[indexdistric],
          width: 1,
        }),
      });
    } else if (
      // properties.type == 'fields' ||
      properties.type == 'Squares' ||
      properties.type == 'Prisms'
      // properties.type == 'Walls' ||
      // properties.type == 'Earth' ||
      // properties.type == 'Districts'
    ) {
      style = new Style({
        stroke: new Stroke({
          color: '#1a1917',
          width: 1,
        }),
      });
    } else {
      style = new Style({
        /*fill: new Fill({
        color: '#ccc5b8',
      }),*/
        stroke: new Stroke({
          color: '#1a1917',
        }),
      });
    }
    return style;
  }

  getFeatureinfo(layerid, latlong, mapcode: string) {
    const viewResolution = this.view.getResolution();
    const findIndex = this.layerlist.findIndex((x) => x.name === 'cells');

    const url = this.wmslayerList[findIndex]
      .getSource()
      .getFeatureInfoUrl(latlong, viewResolution, this.view.getProjection(), {
        INFO_FORMAT: 'application/json',
        FEATURE_COUNT: 15,
        VIEWPARAMS: `mapcode:${mapcode}`, // <-- Add custom mapcode here
      });

    return url;
  }

  // loadlayers(mapCodeData: any) {
  //   // this.initializeMap()
  //   // Throw error if mapCodeData is not provided
  //   if (!mapCodeData) {
  //     throw new Error('mapCodeData is required');
  //   }

  //   // Clear the vector layer source
  //   this.vectorLayer.getSource().clear();

  //   // Set mapid, game_id, character_id, and viewparam based on mapCodeData
  //   this.mapid = mapCodeData.map_id;
  //   this.game_id = mapCodeData.game_id;
  //   this.character_id = mapCodeData.character_id || '';
  //   this.viewparam = "mapcode:" + mapCodeData.map_id;

  //   // Iterate through layerlist and create layers based on their properties

  //   this.layerlist.forEach(lyr => {
  //     if (lyr.name == 'burgs') {
  //       ('found burgs');
  //       var source = new VectorSource();
  //        this.burgLayer = new VectorLayer({
  //         maxZoom: 16,
  //         minZoom: 4,
  //         properties: lyr,
  //         opacity: lyr.opacity,
  //         source: source,
  //         style: (feature) => {

  //           const prop: any = feature.getProperties();
  //           const name = prop.burg;
  //           const currentzoom = this.map.getView().getZoom();
  //           return (currentzoom < 7) ?
  //             new Style({
  //               image: new CircleStyle({
  //                 radius: currentzoom - 4,
  //                 fill: new Fill({
  //                   color: '#797979',
  //                 }),
  //                 /*stroke: new Stroke({
  //                   color: '#797979',
  //                   width:1
  //                 })*/
  //               })
  //             }) : new Style({
  //               image: new CircleStyle({
  //                 radius: currentzoom,
  //                 fill: new Fill({
  //                   color: '#ffffff82',
  //                 }),
  //                 stroke: new Stroke({
  //                   color: '#797979',
  //                   width: 1
  //                 })
  //               }),
  //               text: new Text({
  //                 textAlign: 'center',
  //                 //textBaseline: baseline,
  //                 font: currentzoom + 'px',
  //                 text: name,
  //                 fill: new Fill({ color: '#272727' }),
  //                 //stroke: new Stroke({color: outlineColor, width: outlineWidth}),
  //                 offsetX: 0,
  //                 offsetY: -20,
  //                 // placement: placement,
  //                 //maxAngle: maxAngle,
  //                 // overflow: overflow,
  //                 //rotation: rotation,
  //               })
  //             });
  //         }/*(feature) => {
  //           return mapstyle(feature, lyr.style)
  //         },*/
  //       })
  //       this.loaddata(this.burgLayer)
  //       this.map.addLayer(this.burgLayer)
  //       this.wmslayerList.push(this.burgLayer)

  //     } else {
  //       const layer =(lyr.name == 'state')?
  //         new ImageLayer({
  //           ...lyr,
  //           visible: lyr.visible,
  //           zIndex:0,
  //           source: new ImageWMS({
  //             url: wmsurl, // Add the appropriate wmsurl variable
  //             params: { 'LAYERS': workspace + ':' + lyr.name, 'VIEWPARAMS': this.viewparam ,TRANSPARENT:false,BGCOLOR:'0x183d5c' },
  //             ratio: 1, serverType: 'geoserver'
  //           })}):
  //           new ImageLayer({
  //             ...lyr,
  //             visible: lyr.visible,

  //             source: new ImageWMS({
  //               url: wmsurl, // Add the appropriate wmsurl variable
  //               params: { 'LAYERS': workspace + ':' + lyr.name, 'VIEWPARAMS': this.viewparam  },
  //               ratio: 1, serverType: 'geoserver'
  //             })
  //           })
  //       this.map.addLayer(layer)
  //       this.wmslayerList.push(layer)
  //     }
  //   })

  //   // Add modify interaction for vector layer
  //   const modify = new Modify({ source: this.vectorLayer.getSource() });
  //   this.map.addInteraction(modify);

  //   // Listen for modifyend event and open player story modal if mapCodeData type is "Player"
  //   modify.on('modifystart', (e) => {
  //     e.features.forEach((f: any) => {
  //       const starCoords = f.getGeometry().getCoordinates() as [string, string];
  //       const numericCoords: [number, number] = [parseFloat(starCoords[0]), parseFloat(starCoords[1])];
  //       this.continusCordArray.push(numericCoords);
  //     });

  //     this.startPushing = true
  //   })
  //   this.map.on('pointerdrag', (e)=>{
  //   if(this.startPushing) this.continusCordArray.push(e.coordinate)
  // });
  //   modify.on('modifyend', (e) => {
  //     this.startPushing = false
  //     const geom :any= e.features.getArray()[0].getGeometry();
  //     this.coordinateService.setNewCoordinates(geom.getCoordinates());
  //     this.continusCordArray.push(geom.getCoordinates())
  //     if (mapCodeData.type === "Player") {
  //       const modalRef = this.modalService.open(PlayerStoryComponent,{
  //         size: 'md',
  //         backdrop: 'static',
  //         keyboard: false
  //       })
  //      //
  //       modalRef.result.then((res) => {
  //         if(!res.isUpdate){
  //         if (res) {
  //           this.playerStory = res
  //           this.loadFilters('update',false);
  //         }
  //         else{
  //           this.loadFilters('update',true);
  //         }}
  //       })
  //     }
  //   });
  //   this.getBoundary()
  // }
  loadlayers(mapCodeData: any): void {
    this.mapCodeDataContainer = mapCodeData;
    if (!this.vectorLayer) {
      this.vectorLayer = new VectorLayer({
        zIndex: 202,
        source: new VectorSource(),
      });
      this.map.addLayer(this.vectorLayer);
    }

    if (!mapCodeData) {
      throw new Error('mapCodeData is required');
    }

    // Clear old map and layers
    // this.removeOldMap();

    // Set mapid, game_id, character_id, and viewparam based on mapCodeData
    this.mapid = mapCodeData.map_id;
    this.game_id = mapCodeData.game_id;
    this.character_id = mapCodeData.character_id || '';
    this.viewparam = 'mapcode:' + mapCodeData.map_id;

    // Add layers based on layerlist

    if (mapCodeData.type !== 'Master' && mapCodeData.is_movement) {
      this.addInteraction(mapCodeData);
    }
    this.getBoundary(mapCodeData.isFitExtent);

    // this.layerlist.forEach((lyr) => {
    //   lyr.visible = false;
    //   if (lyr.name === 'culture' || lyr.name === 'border') {
    //     lyr.visible = true;
    //   }
    // });

    // this.layerlist.forEach((lyr) => {
    //   // lyr.visible = false;
    //   if (lyr.name === 'state' || lyr.name === 'border') {
    //     // lyr.visible = true;
    //   }
    // });

    this.layerlist.forEach((lyr) => {
      if (lyr.name === 'burgs') {
        lyr.radius = layerlist.find((l) => l.name === 'border').radius;
        this.addVectorLayer(lyr);
      } else this.addImageLayer(lyr);
    });
  }

  private addVectorLayer(lyr: any): void {
    const source = new VectorSource();
    this.burgLayer = new VectorLayer({
      maxZoom: BURG_LAYER_MAX_ZOOM,
      minZoom: BURG_LAYER_MIN_ZOOM,
      properties: lyr,
      opacity: lyr.opacity,
      source: source,
      style: (feature) => {
        const prop: any = feature.getProperties();
        const name = prop.burg;
        const currentzoom = this.map.getView().getZoom();
        return currentzoom < 6
          ? new Style({
            image: new Icon({
              scale: 0.15,
              // anchor: [0.5, 46],
              src: 'assets/icons/city.png',
            }),
          })
          : new Style({
            image: new Icon({
              // anchor: [0.5, 46],
              scale: 0.3,
              src: 'assets/icons/city.png',
            }),
            text: new Text({
              textAlign: 'center',
              font: currentzoom + 10 + 'px',
              text: name,
              fill: new Fill({ color: '#272727' }),
              stroke: new Stroke({ color: 'white', width: 3 }),
              // backgroundFill: new Fill({ color: 'white' }),
              offsetX: 0,
              offsetY: -30,
            }),
          });
      },
    });
    this.burgLayer.setZIndex(12);
    this.loaddata(this.burgLayer);
    this.map.addLayer(this.burgLayer);
    this.wmslayerList.push(this.burgLayer);
    // this.getBoundary();
  }

  private addImageLayer(lyr: any): void {
    const layer =
      lyr.name === 'border'
        ? new ImageLayer({
          ...lyr,
          visible: lyr.visible,
          zIndex: 0,
          source: new ImageWMS({
            url: wmsurl,
            params: {
              LAYERS: workspace + ':' + lyr.name,
              VIEWPARAMS: this.viewparam,
              TRANSPARENT: false,
              BGCOLOR: '0x183d5c',
            },
            ratio: 1,
            serverType: 'geoserver',
          }),
        })
        : new ImageLayer({
          ...lyr,
          visible: lyr.visible,
          source: new ImageWMS({
            url: wmsurl,
            params: {
              LAYERS: workspace + ':' + lyr.name,
              VIEWPARAMS: this.viewparam,
            },
            ratio: 1,
            serverType: 'geoserver',
          }),
        });
    this.map.addLayer(layer);
    // if (lyr.name === 'cells') layer.setZIndex(1000);
    this.wmslayerList.push(layer);
    // this.getBoundary();
  }

  private addInteraction(mapCodeData) {
    let modify: any = null;

    if (mapCodeData.type !== 'Invitation') {
      this.removeWorldDragTools();
      modify = new Modify({ source: this.vectorLayer.getSource() });
      this.worldModifyInteraction = modify;
      this.map.addInteraction(modify);

      // Listen for modifyend event and open player story modal if mapCodeData type is "Player"
      modify.on('modifystart', (e) => {
        this.handleModifyStart(e);
      });
      this.worldDragHandler = (e) => {
        if (this.startPushing) this.continusCordArray.push(e.coordinate);
      };
      this.map.on('pointerdrag', this.worldDragHandler);
      modify.on('modifyend', (e) => {
        this.handleModifyEnd(e);
      });
    }
    // Add modify interaction for vector layer
  }

  playStoryInsert(
    mapCodeData: MapCodeData,
    coords: number[],
    citycode?: number,
    isCityReached?: boolean,
    char_id?: string,
    isRecall?: boolean | null | undefined,
    context?: JournalContext,
  ): void {
    if (mapCodeData.type !== 'Player' && mapCodeData.type !== 'Master') {
      this.setMoveLock(false);
      return;
    }
    this.setMoveLock(true);

    const modalRef = this.modalService.open(PlayerStoryComponent, {
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true,
    });
    // tell the journal what is moving and where to
    const isParty = this.getpartybygame === 'gamemaster';
    const inCity = !!citycode && !isCityReached;
    const journal = modalRef.componentInstance as PlayerStoryComponent;
    journal.kind = inCity ? (isParty ? 'city-party' : 'city-character') : (isParty ? 'party' : 'character');
    journal.destination = context?.destination || '';
    journal.suggestedTitle = context?.suggestedTitle || (inCity ? 'Moved through the city' : 'On the road');
    journal.cityName = isCityReached ? context?.cityName || 'the city' : '';

    modalRef.result
      .then((res: StoryResponse) => {
        // a title is required, the entry is optional
        if (res?.title) {
          this.pendingEnterCity = !!res.enterCity;
          this.processStoryResponse(
            res,
            mapCodeData,
            coords,
            citycode,
            isCityReached,
            char_id,
          );
        } else {
          this.setMoveLock(false); // cancelled
          if (!isRecall) {
            this.resetCoordinateArrays();
            this.restoreTokenToPrevious(
              this.playerFeature,
              this.playerCurrentLocationCords,
            );
          } else {
            this.cleanupInvalidPlacement();
            this.destroyCityDraw();
            this.initCityDraw(true);
          }
        }
      })

      .catch((err) => {
        this.setMoveLock(false);
        console.error('Modal failed:', err);
      });
  }

  private processStoryResponse(
    res: StoryResponse | null,
    mapCodeData: MapCodeData,
    coords: number[],
    citycode?: number,
    isCityReached?: boolean,
    char_id?: string,
  ): void {
    if (!res || res.updateStory) {
      this.setMoveLock(false);
      this.resetCoordinateArrays();
      return;
    }

    this.playerStory = { title: res.title, details: res.details };
    const isWorldUpdate = !citycode || (citycode && isCityReached);
    const data: StoryData = this.buildStoryData(
      mapCodeData,
      coords,
      isWorldUpdate,
      citycode,
    );

    this.getpartybygame === 'gamemaster'
      ? this.updateGameMaster(
        data,
        mapCodeData,
        citycode,
        isWorldUpdate,
        isCityReached,
      )
      : this.updatePlayer(
        data,
        mapCodeData,
        citycode,
        isWorldUpdate,
        isCityReached,
        char_id,
      );
  }

  private buildStoryData(
    mapCodeData: MapCodeData,
    coords: number[],
    isWorldUpdate: boolean,
    citycode?: number,
  ): StoryData {
    return {
      id: this.getpartybygame === 'gamemaster' ? this.Id : this.character_id,
      details: this.playerStory.details?.trim(),
      title: this.playerStory.title?.trim(),
      location: `${coords[0]},${coords[1]}`,
      character_id: mapCodeData.character_id,
      game_id: mapCodeData.game_id || '',
      movements: isWorldUpdate
        ? this.continusCordArray
        : this.continusCityCordArray,
      mapcode: mapCodeData.map_id,
      citycode: !isWorldUpdate ? citycode : undefined,
    };
  }

  private updateGameMaster(
    data: StoryData,
    mapCodeData: MapCodeData,
    citycode: number | undefined,
    isWorldUpdate: boolean,
    isCityReached?: boolean,
  ): void {
    const updateMethod = isWorldUpdate
      ? this.updatelocationbypartytoken(data)
      : this.cityDataService.citylocationhistory(data);

    updateMethod.subscribe({
      next: (response: any) => {
        this.setMoveLock(false);
        this.handleUpdateSuccess(
          response,
          mapCodeData,
          citycode,
          isWorldUpdate,
          isCityReached,
        );
        const currentCoords = response.current_location
          ? response.current_location.split(',')
          : response.location_history.current_location.split(',');
        this.playerCurrentLocationCords = currentCoords.map(Number);
      },
      error: (err) => {
        this.setMoveLock(false);
        this.restoreTokenToPrevious(
          this.playerFeature,
          this.playerCurrentLocationCords,
        );
        console.error(`Game master update failed:`, err);
      },
    });
  }

  private updatePlayer(
    data: StoryData,
    mapCodeData: MapCodeData,
    citycode: number | undefined,
    isWorldUpdate: boolean,
    isCityReached?: boolean,
    char_id?: string,
  ): void {
    data.id = mapCodeData.type === 'Player' ? this.character_id : char_id;
    if (!isWorldUpdate) data.character_id = this.character_id || this.Id;

    const updateMethod = isWorldUpdate
      ? this.updatePlayerCoordinates(data.id, data)
      : this.cityDataService.insertCityHistoryData(data.character_id, data);

    updateMethod.subscribe({
      next: (response: any) => {
        this.setMoveLock(false);
        this.handleUpdateSuccess(
          response,
          mapCodeData,
          citycode,
          isWorldUpdate,
          isCityReached,
          char_id,
        );

        const currentCoords = response.current_location
          ? response.current_location.split(',')
          : response.movement_history.current_location.split(',');
        this.playerCurrentLocationCords = currentCoords.map(Number);
      },
      error: (err) => {
        this.setMoveLock(false);
        this.restoreTokenToPrevious(
          this.playerFeature,
          this.playerCurrentLocationCords,
        );
        console.error(`Game master update failed:`, err);
      },
    });
  }

  private handleUpdateSuccess(
    response: any,
    mapCodeData: MapCodeData,
    citycode: number | undefined,
    isWorldUpdate: boolean,
    isCityReached?: boolean,
    char_id?: string,
  ): void {
    if (!response) return;

    const charId = char_id || this.character_id || this.Id;
    const historyMethod = this.getHistoryMethod(
      mapCodeData,
      citycode,
      charId,
      isWorldUpdate,
    );

    historyMethod.subscribe({
      next: (historyDetails) =>
        this.processHistory(
          historyDetails,
          mapCodeData,
          citycode,
          isWorldUpdate,
          isCityReached,
        ),
      error: (err) => console.error('History fetch failed:', err),
    });
  }

  private getHistoryMethod(
    mapCodeData: MapCodeData,
    citycode: number | undefined,
    charId: string,
    isWorldUpdate: boolean,
  ) {
    if (this.getpartybygame === 'gamemaster') {
      return isWorldUpdate
        ? this.DataService.partylocationhistory(this.Id, mapCodeData.map_id)
        : this.cityDataService.getCitylocationhistoryGame(
          charId,
          mapCodeData.map_id,
          citycode,
        );
    }
    return isWorldUpdate
      ? this.DataService.getHistoryDetailByCharacterId(
        charId,
        mapCodeData.map_id,
      )
      : this.cityDataService.getCityHistoryData(
        charId,
        mapCodeData.map_id,
        citycode,
      );
  }

  private processHistory(
    historyDetails: any,
    mapCodeData: MapCodeData,
    citycode: number | undefined,
    isWorldUpdate: boolean,
    isCityReached?: boolean,
  ): void {
    if (!historyDetails) return;

    const records =
      this.getpartybygame === 'gamemaster' && !isWorldUpdate
        ? historyDetails.party_location_history
        : historyDetails.res || historyDetails;

    if (isWorldUpdate) {
      this.coordinateService.setNewHistoryRecords(records);
      if (this.layerRedPathHighlightLayer)
        this.layerRedPathHighlightLayer.getSource().clear();
      this.continusCordArray = [];
      if (isCityReached && citycode && this.pendingEnterCity) this.enterCityNow(mapCodeData, citycode);
      this.pendingEnterCity = false;
    } else {
      if (records.length > 0) this.continusCityCordArray = [];
      this.coordinateService.setNewCityHistoryRecords(records);
      // if (this.layerRedPathHighlightCityLayer)
      //   this.layerRedPathHighlightCityLayer.getSource().clear();
    }
  }

  /**
   * Into the city the move ended on. Chosen in the journal ("Enter <city>
   * after this move"), so it no longer asks again in two more windows; the
   * city screen explains where to place the token.
   */
  private enterCityNow(mapCodeData: MapCodeData, citycode: number): void {
    sessionStorage.setItem('outerMapCurrentZoom', this.map.getView().getZoom().toString());
    this.router.navigate(
      [
        '/city-map-view',
        citycode,
        this.mapCodeDataContainer.map_id,
        mapCodeData.game_id || 'null',
        mapCodeData.character_id || 'null',
      ],
      {
        queryParams: {
          token: this.userProfileUrl,
          isLoadToken: true,
          game_system: this.game_system || null,
          backRoute: mapCodeData.cityBackNavigate || 'default-route',
        },
      },
    );
  }

  /** What the journal shows for a spot on the world map. */
  private journalContextForCell(cell: CellDetails | null): JournalContext {
    if (!cell) return {};
    const city = cell.burg_id > 0 ? (cell.burg || cell.burgs_data?.['name'] || '') : '';
    const region = cell.province && cell.province !== 'None' ? cell.province : cell.state && cell.state !== 'None' ? cell.state : '';
    const biome = cell.biome && cell.biome !== 'None' ? cell.biome : '';
    if (city) {
      return { destination: city, suggestedTitle: `Arrived at ${city}`, cityName: city };
    }
    if (biome.toLowerCase() === 'marine') {
      return { destination: region ? `At sea off ${region}` : 'At sea', suggestedTitle: 'Out at sea' };
    }
    return {
      destination: [region, biome].filter(Boolean).join(' \u00b7 '),
      suggestedTitle: region ? `Travelled to ${region}` : biome ? `Crossed the ${biome.toLowerCase()}` : 'On the road',
    };
  }

  /** Lock or unlock dragging tokens (world and city maps). */
  private setMoveLock(locked: boolean): void {
    this.moveLocked = locked;
    [this.map, this.map1].forEach((m) => {
      m?.getInteractions().forEach((i) => {
        if (i instanceof Modify) i.setActive(!locked);
      });
    });
  }

  /** A drop that can't be saved: token back where it was, and say so. */
  private moveNotSaved(message: string): void {
    this.setMoveLock(false);
    this.resetCoordinateArrays();
    if (this.playerFeature && this.playerCurrentLocationCords) {
      this.restoreTokenToPrevious(this.playerFeature, this.playerCurrentLocationCords);
    }
    this.toasterService.showNote(message, 'warning');
  }

  private removeWorldDragTools(): void {
    this.moveLocked = false; // a new map starts unlocked
    if (!this.map) return;
    if (this.worldModifyInteraction) this.map.removeInteraction(this.worldModifyInteraction);
    if (this.partyModifyInteraction) this.map.removeInteraction(this.partyModifyInteraction);
    if (this.worldDragHandler) this.map.un('pointerdrag', this.worldDragHandler);
    this.worldModifyInteraction = null;
    this.partyModifyInteraction = null;
    this.worldDragHandler = null;
  }

  private resetCoordinateArrays(): void {
    this.continusCordArray = [];
    this.continusCityCordArray = [];
  }

  restoreTokenToPrevious(feature: any, coords: any) {
    feature.setGeometry(new Point(coords));
    const isInside = this.isPointInsidePolygon(
      coords,
      this.cityLandCoordinates,
    );

    this.coordinateService.setAtCityBoundary(!isInside);
  }

  extractMovements(data: any[]): number[][][] {
    return data.map((item) => {
      let movementsArray: number[][] = item.movements;

      return movementsArray;
    });
  }

  /**
   * This code snippet defines a method getBoundary that fetches boundary data from a DataService
   * based on a mapid, processes the data, adjusts map view, and updates layers on the map
   * accordingly. It involves working with GeoJSON features to set boundaries and update layers
   * with specific conditions.
   */

  getBoundary(isFitExtent: boolean | undefined | null) {
    // Call the DataService to get boundary data based on the mapid
    this.DataService.getboundaryData(this.mapid).subscribe((data: any) => {
      // Extract the features from the received data
      const features = data.features;
      // Create a new GeoJSON feature from the first feature in the data
      this.borderCropFeat = new GeoJSON().readFeature(features[0]);
      if (isFitExtent) {
        // Adjust the map view to fit the extent of the newly created feature
        this.map.getView().fit(this.borderCropFeat.getGeometry().getExtent(), {
          maxZoom: 3,
          duration: 500,
        });
      }
      // Iterate through the layerlist to update layers based on the boundary data
      this.layerlist.forEach((lyr: any) => {
        // Iterate through the map's layers to find matching layers
        this.map.getLayers().forEach((maplyr: any) => {
          // If the layer names match, update the layer with the boundary data
          if (maplyr.get('name') === lyr.name && lyr.name == 'rivers') {
            // If the layer has a crop property, remove the crop and deactivate it
            if (lyr['crop']) {
              maplyr.removeFilter(lyr['crop']);
              lyr['crop'].set('active', false);
            }
            // Set the feature of the layer to the boundary feature
            lyr['feature'] = this.borderCropFeat;
            // Create a new Crop object for the boundary layer or update the existing crop
            if (lyr.name == 'boundary') {
              lyr['crop'] = new Crop({
                feature: lyr['feature'],
                wrapX: true,
                inner: false,
                shadowWidth: 0,
              });
            } else {
              lyr['crop'] = new Crop({
                feature: lyr['feature'],
                wrapX: true,
                inner: false,
                shadowWidth: 0,
              });
              lyr['crop'].set('active', true);
              maplyr.addFilter(lyr['crop']);
            }
          }
        });
      });
    });
  }

  addPointDrawInteraction(character, coordinates?, type?): void {
    // Clear the existing features from the vector layer
    // this.vectorLayer.getSource().clear();
    // If a specific type is provided
    if (type) {
      // Create a new point feature and add it to the vector layer
      const pointFeature = new Feature({
        geometry: new Point(coordinates),
      });
      pointFeature.setStyle(
        new Style({
          image: new Icon({
            // Use the character's image if available, otherwise use a default path
            src:
              ip +
              (character.image
                ? character.image
                : ip + '/media/media/char_detail_imgs/spotonmap_4_Images.png'),
            scale: 0.5,
          }),
        }),
      );
      this.vectorLayer.getSource().addFeature(pointFeature);
    } else {
      // If no specific type is provided
      this.mainDrawInteraction = new Draw({
        source: this.vectorLayer.getSource(),
        type: 'Point',
        style: new Style({
          image: new Icon({
            src: character
              ? ip + (character.image || 'assets/images/ac-token-game-large.png')
              : 'assets/images/ac-token-game-large.png',
            scale: 0.5,
          }),
        }),
      });

      // Update the drawing style when drawing starts
      this.mainDrawInteraction.on('drawstart', (event) => {
        const feature = event.feature;
        feature.setStyle(
          new Style({
            image: new Icon({
              src: character
                ? ip + (character.image || 'assets/images/ac-token-game-large.png')
                : 'assets/images/ac-token-game-large.png',
              scale: 0.5,
            }),
          }),
        );
      });

      // Handle the drawn point when drawing ends
      this.mainDrawInteraction.on('drawend', (event) => {
        this.map.removeInteraction(this.mainDrawInteraction);
        const feature = event.feature;
        const geometry = feature.getGeometry() as Point;
        const drawnCoordinates: [number, number] =
          geometry.getCoordinates() as [number, number];
        this.coordinateService.setNewCoordinates(drawnCoordinates);
        this.getMapInfo(drawnCoordinates);
        // Add modify interaction after drawing ends
        this.addModifyInteraction(feature);
      });

      // Add the draw interaction to the map
      this.map.addInteraction(this.mainDrawInteraction);
    }
  }

  getMapInfo(coordinates: [number, number]): void {
    this.DataService.getCustomCellData({
      longitude: coordinates[0],
      latitude: coordinates[1],
      map_code: this.mapCodeDataContainer.map_id,
    }).subscribe((data: CellDetails) => {
      const resourceObj = this.processResourceObjectToPass(data);
      if (data && data.burg_id) {
        this.infoBarService.setNewInfo({
          resource_values: resourceObj,
          burg_values: data.burgs_data,
        });
        // this.coordinateService.setNewCellResourceDetails(data);
      } else {
        this.infoBarService.setNewInfo({
          resource_values: resourceObj,
          burg_values: null,
        });
      }
    });
  }

  addModifyInteraction(feature: Feature): void {
    // Remove any existing modify interaction to avoid duplicates
    if (this.modifyInteraction) {
      this.map.removeInteraction(this.modifyInteraction);
    }

    // Create a new modify interaction for the drawn feature
    this.modifyInteraction = new Modify({
      features: new Collection([feature]), // Only allow modifying this specific feature
    });

    // Handle the end of modification (dragend equivalent)
    this.modifyInteraction.on('modifyend', (event) => {
      const modifiedFeature = event.features.getArray()[0];
      const geometry = modifiedFeature.getGeometry() as Point;
      const newCoordinates: [number, number] = geometry.getCoordinates() as [
        number,
        number,
      ];
      this.coordinateService.setNewCoordinates(newCoordinates);
      this.getMapInfo(newCoordinates);
    });

    // Add the modify interaction to the map
    this.map.addInteraction(this.modifyInteraction);
  }

  async addListofPoints(pointlist: any[] | any): Promise<any> {
    // Handle both array or single object
    const points = Array.isArray(pointlist) ? pointlist : [pointlist];

    // Define the pointerdrag handler
    let pointDragHandler = (evt: any) => {
      if (this.startPushing) this.continusCordArray.push(evt.coordinate);
    };

    // Unbind and rebind the pointerdrag handler
    this.map.un('pointerdrag', pointDragHandler);
    this.map.on('pointerdrag', pointDragHandler);

    // Iterate through the list of points
    for (const feat of points) {
      if (
        (feat.Location && feat.Location.split(',').length > 1) ||
        (feat.current_location && feat.current_location.split(',').length > 1)
      ) {
        const coordinates = this.processPlayerCurrentPlace(feat);

        const feature = new Feature({
          geometry: new Point(coordinates.map((coord) => parseFloat(coord))),
        });

        feature.set('character_id', feat.character_id);
        feature.set('isActive', feat.is_active);
        feature.set('is_retired', feat.is_retired);
        feature.set('is_dead', feat.is_dead);
        if (feat.not_movable) feature.set('not_movable', feat.not_movable);
        this.userProfileUrl = feat.cropped_image;

        feature.setStyle(
          new Style({
            image: new Icon({
              src: ip + this.userProfileUrl,
              scale: 0.5,
            }),
          }),
        );

        this.playerFeature = feature;
        this.playerCurrentLocationCords = coordinates;
        this.vectorLayer.getSource().addFeature(feature);
      }
    }
  }

  private processPlayerCurrentPlace(character: any): string[] {
    let coordinates: string[] = [];
    if (
      character.is_in_city &&
      character.last_map_location &&
      character.last_map_location.split(',').length > 1
    ) {
      coordinates = character.last_map_location.split(',');
    } else if (
      character.current_location &&
      character.current_location.split(',').length > 1
    ) {
      coordinates = character.current_location.split(',');
    }
    return coordinates;
  }
  // The image feature being dragged

  async addListofPointsmaptoken(
    pointlist: GameDetailsById[],
    getpartybygame: any,
    isOnlyBack: boolean = false,
    isCityVisited: boolean = false,
  ): Promise<any> {
    this.getpartybygame = getpartybygame;
    this.Id = pointlist[0].id;

    //!pointlist[0].is_in_city
    if (true) {
      let pointDragHandler = (evt: any) => {
        if (this.startPushing) this.continusCordArray.push(evt.coordinate);
      };

      this.map.un('pointerdrag', pointDragHandler);
      this.map.on('pointerdrag', pointDragHandler);
      let coordinates: number[] = [];

      for (const feat of pointlist) {
        if (
          (feat.last_map_location &&
            feat.last_map_location.split(',').length > 1) ||
          (feat.spawn_location && feat.spawn_location.split(',').length > 1) ||
          (feat.initial_party_location &&
            feat.initial_party_location.split(',').length > 1)
        ) {
          let coordinates: number[] = [];
          if (feat.spawn_city && feat.spawn_city.length > 0) {
            coordinates =
              feat.last_map_location?.split(',')?.map(Number) ||
              feat.initial_party_location?.split(',')?.map(Number) ||
              [];
          } else {
            coordinates =
              feat.spawn_location?.split(',')?.map(Number) ||
              feat.last_map_location?.split(',')?.map(Number) ||
              feat.initial_party_location?.split(',')?.map(Number) ||
              [];
          }

          // Add the image feature
          const feature = new Feature({
            geometry: new Point(coordinates),
          });

          // if(getpartybygame !== 'gamemaster') {
          //   this.userProfileUrl = ip + feat.image;
          // }

          this.userProfileUrl = feat.partytoken;

          feature.setStyle(
            new Style({
              image: new Icon({
                src: ip + this.userProfileUrl,
                scale: 0.5,
              }),
            }),
          );

          this.vectorLayer.getSource().addFeature(feature);

          // Enable dragging
          if (!isOnlyBack) {
            if (this.partyModifyInteraction) {
              this.map.removeInteraction(this.partyModifyInteraction);
            }
            const modify = new Modify({
              source: this.vectorLayer.getSource(),
            });
            this.partyModifyInteraction = modify;
            this.map.addInteraction(modify);
            modify.on('modifystart', (evt) => this.handleModifyStart(evt));
            modify.on('modifyend', (evt) => this.handleModifyEnd(evt, feat.id));
          }

          if (isCityVisited) {
            const cityExtentJSON = localStorage.getItem('lastCityVisited');
            if (cityExtentJSON) {
              const cityExtent = JSON.parse(cityExtentJSON);
              this.map.getView().fit(cityExtent, {
                duration: 1000,
                padding: [50, 50, 50, 50],
                maxZoom: 12,
              });
            }
          } else {
            this.map.once('postrender', () => {
              const view = this.map.getView();
              view.fit(feature.getGeometry().getExtent(), {
                duration: 1000,
                padding: [50, 50, 50, 50],
                maxZoom: DEFAULT_ZOOM,
              });
            });
          }

          // Store the dragged feature for line drawing
          this.draggedFeature = feature;
          this.continusCordArray = [coordinates]; // Initialize the array
          this.playerFeature = feature;
          this.playerCurrentLocationCords = coordinates;
        }
      }
    } else {
    }
  }

  // Function to update the line dynamically
  // updateLineFeature() {
  //   if (this.lineFeature) {
  //     this.vectorLayer.getSource().removeFeature(this.lineFeature);
  //   }

  //   this.lineFeature = new Feature({
  //     geometry: new LineString(this.continusCordArray),
  //   });

  //   this.lineFeature.setStyle(
  //     new Style({
  //       stroke: new Stroke({
  //         color: 'blue',
  //         width: 2,
  //       }),
  //     })
  //   );

  //   this.vectorLayer.getSource().addFeature(this.lineFeature);
  // }

  // Define the modifystart handler
  private handleModifyStart(evt: any): void {
    evt.features.forEach((f: any) => {
      const starCoords = f.getGeometry().getCoordinates() as [string, string];
      const numericCoords: [number, number] = [
        parseFloat(starCoords[0]),
        parseFloat(starCoords[1]),
      ];

      this.continusCordArray.push(numericCoords);
    });

    this.startPushing = true;
  }

  // Define the modifyend handler
  private handleModifyEnd(evt: any, char_id?: any): void {
    this.startPushing = false;
    if (this.moveLocked) {
      // another move is still open: this drag doesn't count
      this.resetCoordinateArrays();
      if (this.playerFeature && this.playerCurrentLocationCords) {
        this.restoreTokenToPrevious(this.playerFeature, this.playerCurrentLocationCords);
      }
      return;
    }
    this.setMoveLock(true);

    const geom: any = evt.features.getArray()[0].getGeometry();
    const coordsToPass = geom.getCoordinates() as [number, number];
    this.coordinateService.setNewCoordinates(geom.getCoordinates());
    this.continusCordArray.push(geom.getCoordinates());

    const viewResolution = this.view.getResolution();
    const coords = this.continusCordArray[this.continusCordArray.length - 1];
    const findIndex = this.layerlist.findIndex((lyr) => lyr.name === 'cells');

    const url = this.wmslayerList[findIndex]
      .getSource()
      .getFeatureInfoUrl(coords, viewResolution, this.view.getProjection(), {
        INFO_FORMAT: 'application/json',
        FEATURE_COUNT: 1,
      });

    this.DataService.getCustomCellData({
      longitude: coordsToPass[0],
      latitude: coordsToPass[1],
      map_code: this.mapCodeDataContainer.map_id,
    }).subscribe({
      next: (res: CellDetails) => {
        const context = this.journalContextForCell(res);
        if (res?.burg_id === 0) {
          this.playStoryInsert(
            this.mapCodeDataContainer,
            coords,
            null,
            false,
            char_id,
            null,
            context,
          );
        } else if (res?.burg_id > 0) {
          // this.infoBarService.setNewInfo({ feature, sideInfo: false });
          this.cityCode = res.burg_id;
          this.playStoryInsert(
            this.mapCodeDataContainer,
            coords,
            this.cityCode,
            true,
            char_id,
            null,
            context,
          );
        } else {
          // no land under the token (off the map): nothing to save
          this.moveNotSaved("There's no land there. The token went back.");
        }
      },
      // the spot couldn't be checked: the move was never saved, so don't
      // leave the token where it looks moved
      error: () => this.moveNotSaved("We couldn't check that spot, so the move wasn't saved."),
    });
  }

  // applyRadius(newdata: any) {
  //   // Iterate through the layer list to find the matching layer by name
  //   this.layerlist.forEach((lyr) => {
  //     // If the layer name matches the new data's layer name, update the radius
  //     if (lyr.name === newdata.layer_name) {
  //       lyr['radius'] = newdata.total_sum;
  //     }
  //   });

  //   // Load filters for radius
  //   // this.loadFilters('radius', true);
  // }

  /**
   * Asynchronously loads filters based on the provided parameters.
   * @param {any} params - The parameters for loading the filters.
   */
  async loadFilters(
    params: any,
    isCancel: boolean,
    coordsArray?: any,
    isRetainZoom?: boolean,
    dataOfRadius?: any,
  ) {
    dataOfRadius.forEach((data) => {
      // Iterate through the layer list to find the matching layer by name
      this.layerlist.forEach((lyr) => {
        if (lyr.name === data.layer_name) {
          lyr['radius'] = data.total_sum;
        } else if (lyr.name === 'border') {
          lyr['radius'] =
            dataOfRadius.find((d) => d.layer_name === 'borders')?.total_sum ||
            0;
        }
      });
    });
    // Get features from the vector layer source
    if (!this.vectorLayer) {
      this.vectorLayer = new VectorLayer({
        source: new VectorSource(),
      });
    }
    const features = this.vectorLayer.getSource().getFeatures();
    let coordinates;

    // Iterate through each feature
    for (const feat of features) {
      // Get the geometry and coordinates of the feature
      const geom: any = feat.getGeometry();
      coordinates = coordsArray ? coordsArray : geom.getCoordinates();

      if (Array.isArray(coordinates[0])) {
        // If coordinates are an array, compute extent and fit view
        const extent = boundingExtent(coordinates);
        // this.view.fit(extent, { duration: 1000, padding: [50, 50, 50, 50] });
      } else {
        // If single coordinate, just center and zoom
        this.view.setCenter(coordinates);
        // this.view.setZoom(5);
      }

      // Set filter based on the coordinates
      await this.setFilter(
        coordinates,
        coordsArray ? true : undefined,
        isRetainZoom,
      );
    }

    // If params is not 'radius', update player coordinates
    if (params !== 'radius' && isCancel !== true) {
      // Your existing logic
    } else {
      this.continusCordArray = [];
    }
  }

  setFilter(coordinates: any, isMovements?: boolean, isRetainZoom?: boolean) {
    let referenceMetrics: CropMetrics | undefined;
    let stateRadius = 0;

    // crop for all layers in layerlist
    this.layerlist.forEach((lyr: any) => {
      this.map.getLayers().forEach((mapLayer: any) => {
        if (mapLayer.get('name') === lyr.name && lyr.radius > 0) {
          if (lyr.name === 'state') {
            stateRadius = lyr.radius;
          }
          this.applyCropToLayer(mapLayer, lyr, coordinates, isMovements);
          // pick the one you want to "mirror"; here we simply take the first one
        }
      });
    });

    // crop for contentPinLayer as well
    if (this.layerContentPinLayer) {
      // if you instead want a radius-like number, you can use:
      // const r = referenceMetrics?.meanRadius ?? 100;

      this.processCrop(coordinates, isMovements, stateRadius);
    } else {
      this.layerContentPinLayer = new VectorLayer({
        source: new VectorSource(),
        minZoom: 6,
        zIndex: 999,
      });
      this.processCrop(coordinates, isMovements);
    }

    // zoom adjust
    const getExtent = this.vectorLayer.getSource().getExtent();
    this.map.getView().fit(getExtent, {
      maxZoom: isRetainZoom ? this.map.getView().getZoom() : 10,
      duration: 500,
    });
  }

  processCrop(coordinates: any, isMovements?: boolean, stateRadius?: number) {
    if (
      this.layerContentPinLayerInstance &&
      this.layerContentPinLayerInstance['crop']
    ) {
      // (this.layerContentPinLayer as any).removeFilter(this.layerContentPinLayerInstance['crop']);
    }
    const pinLayerConfig = {
      name: 'contentPinLayer',
      radius: stateRadius || 5,
      feature: this.layerContentPinLayerInstance
        ? this.layerContentPinLayerInstance['feature']
        : undefined,
      crop: this.layerContentPinLayerInstance
        ? this.layerContentPinLayerInstance['crop']
        : undefined,
    };

    this.applyCropToLayer(
      this.layerContentPinLayer,
      pinLayerConfig,
      coordinates,
      isMovements,
    );
  }

  polygonMetrics(poly: Polygon): CropMetrics {
    const proj = this.map.getView().getProjection();

    const perimeter = geodesicLength(poly, { projection: proj });
    const area = geodesicArea(poly, { projection: proj });

    const extent = poly.getExtent();
    const width = getWidth(extent);
    const height = getHeight(extent);

    const rx = width / 2;
    const ry = height / 2;

    const meanRadius = (rx + ry) / 2;
    const eqCircleRadius = Math.sqrt(area / Math.PI);

    return {
      perimeter,
      area,
      width,
      height,
      rx,
      ry,
      meanRadius,
      eqCircleRadius,
    };
  }
  private applyCropToLayer(
    mapLayer: any,
    lyr: any,
    coordinates: any,
    isMovements?: boolean,
  ): CropMetrics | undefined {
    // remove old crop if exists
    if (lyr.name === 'state') {
    }
    if (lyr['crop']) {
      mapLayer.removeFilter(lyr['crop']);
      lyr['crop'].set('active', false);
    }
    if (lyr['feature'] === this.borderCropFeat) {
      lyr['feature'] = undefined;
    }

    // build geometry
    let geometry;
    if (Array.isArray(coordinates[0]) && coordinates.length > 1) {
      geometry = this.getPolygonLinestring(
        lyr.radius,
        coordinates,
        lyr['feature'],
      );
    } else {
      geometry = this.getPolygon(lyr.radius, coordinates, lyr['feature']);
    }

    // set feature
    if (isMovements && geometry && geometry.length > 0) {
      lyr['feature'] = new Feature({ geometry: new Polygon(geometry) });
    } else {
      // geometry is already an OL geometry here
      lyr['feature'] = new Feature(geometry);
    }

    if (!lyr['feature']) return null;

    // ---- measure the crop shape
    const poly = lyr['feature'].getGeometry() as Polygon;
    const metrics = this.polygonMetrics(poly);

    // stash metrics wherever you like
    lyr['metrics'] = metrics;
    mapLayer.set('cropMetrics', metrics);

    // ---- apply the crop filter
    lyr['crop'] = new Crop({
      feature: lyr['feature'],
      wrapX: true,
      inner: false,
      shadowWidth: 0,
    });
    lyr['crop'].set('active', true);
    if (lyr.name === 'contentPinLayer') {
      this.layerContentPinLayerInstance = lyr;
    }
    mapLayer.addFilter(lyr['crop']);

    return metrics;
  }

  citySetFilter(coordinates: any, isMovments?: any) {
    this.layerlist.forEach((lyr: any) => {
      if (lyr.radius > 0) {
        this.map1.getLayers().forEach((maplyr: any) => {
          if (lyr['crop']) {
            maplyr.removeFilter(lyr['crop']);
            lyr['crop'].set('active', false);
          }
          if (lyr['feature'] == this.borderCropFeat) {
            lyr['feature'] = undefined;
          }

          let geometry;

          if (Array.isArray(coordinates[0])) {
            // If it's an array (array of coordinates), create a polygon from the bounding box
            geometry = this.getPolygonLinestring(
              lyr.radius,
              coordinates,
              lyr['feature'] ? lyr['feature'] : undefined,
            );
          } else {
            // Single coordinate case (existing logic)
            geometry = this.getPolygon(
              lyr.radius,
              coordinates,
              lyr['feature'] ? lyr['feature'] : undefined,
            );
          }

          // Ensure that geometry is valid before creating a feature
          if (isMovments && geometry && geometry.length > 0) {
            // Create the feature based on the geometry (ensure geometry is correct type)
            lyr['feature'] = new Feature({
              geometry: new Polygon(geometry), // Ensure to wrap the coordinates as a Polygon
            });

            if (lyr['feature']) {
              lyr['crop'] = new Crop({
                feature: lyr['feature'],
                wrapX: true,
                inner: false,
                shadowWidth: 0,
              });
              lyr['crop'].set('active', true);
              maplyr.addFilter(lyr['crop']);
            }
          } else {
            lyr['feature'] = new Feature(
              this.getPolygon(
                lyr.radius,
                coordinates,
                lyr['feature'] ? lyr['feature'] : undefined,
              ),
            );
            if (lyr['feature']) {
              lyr['crop'] = new Crop({
                feature: lyr['feature'],
                wrapX: true,
                inner: false,
                shadowWidth: 0,
              });
              lyr['crop'].set('active', true);
              maplyr.addFilter(lyr['crop']);
              maplyr.addFilter(lyr['crop']);
            }
          }
        });
      }
    });
  }

  getPolygonFromExtent(coordinates: number[][]): Polygon {
    if (!Array.isArray(coordinates) || coordinates.length === 0) {
      console.error('Invalid coordinates provided');
      return null;
    }

    const extent = boundingExtent(coordinates); // Get the bounding extent
    const polygon = new Polygon([
      [
        [extent[0], extent[1]], // Bottom-left
        [extent[0], extent[3]], // Top-left
        [extent[2], extent[3]], // Top-right
        [extent[2], extent[1]], // Bottom-right
        [extent[0], extent[1]], // Closing the polygon
      ],
    ]);

    return polygon;
  }

  getPolygon(
    radius: any,
    coordinates: any,
    feat: any,
  ): MultiPolygon | undefined {
    radius = radius > 0 ? radius * 100 : 1;
    if (!coordinates?.length) {
      return undefined;
    }

    // 🔁 Flatten if 2D array is passed
    if (Array.isArray(coordinates[0])) {
      coordinates = coordinates[0]; // take the first set if it's [[lng, lat]]
    }

    const newoptions: any = {
      steps: 100,
      units: 'kilometers',
      properties: { foo: 'bar' },
    };

    try {
      const circle = turf.circle(coordinates, radius, newoptions);
      return new MultiPolygon([circle.geometry.coordinates]);
    } catch (error) {
      console.error('Error creating circle polygon:', error);
      return undefined;
    }
  }

  getPolygonLinestring(
    radius: number,
    coordinates: any,
    feat: any,
  ): any | undefined {
    radius = radius > 0 ? radius * 100 : 1; // Ensure radius is in a valid unit
    if (!coordinates?.length) {
      return undefined; // Return undefined if coordinates are empty
    } else {
      const options: any = {
        steps: 100,
        units: 'kilometers', // Specify the units (can be 'meters', 'miles', etc.)
        properties: { foo: 'bar' }, // Add any additional properties here
      };

      // Generate a LineString from the provided coordinates
      const line = turf.lineString(coordinates);

      // Generate a buffer around the LineString using turf.buffer
      const buffer = turf.buffer(line, radius, options);

      // Return the coordinates of the buffer (which could be a polygon or MultiPolygon)
      return buffer.geometry.coordinates;
    }
  }

  // first build line feature
  // line feature pass in turf.buffer

  getLayerDetail(character_id): Observable<any> {
    return this.http.get(serviceurl + 'layer/' + character_id + '/');
  }

  filterAndToggleLayers(layers: any): void {
    const activeLayers = layers.filter((lyr) => lyr.checked);
    let activeLayerNames = activeLayers.map((lyr) => lyr.name);
    activeLayerNames = [...this.arrayOfLayerNames, ...activeLayerNames];
    const mapLayers = this.map.getLayers().getArray();

    this.layerlist.forEach((layer) => {
      layer.checked = activeLayerNames.includes(layer.name);
      const targetLayer = mapLayers.find(
        (lyr) => lyr.get('name') === layer.name || lyr.get('name') === 'burgs',
      );
      if (targetLayer) {
        targetLayer.setVisible(!!layer.checked);
      }
    });
  }

  updatePlayerCoordinates(characterId, data) {
    return this.http.put(
      serviceurl + `character/UpdatedLocationbyCharcaterId/${characterId}/`,
      data,
    );
  }

  updatelocationbypartytoken(data) {
    return this.http.post(
      serviceurl + `api/party/create-location-by-party-token/`,
      data,
    );
  }

  getCharacterLocationHistoryByCharId(charID) {
    return this.http.get(
      serviceurl + 'sharedlocation/getbycharacteridlocationid/' + charID,
    );
  } // Property to store the reference to the event listener function

  handleMapClick(addListener: boolean, isCityMap: boolean) {
    this.isSideInfo = false;
    if (addListener) {
      this.handleMapClickHandler = (event) => {
        this.playerCoordinates = event.coordinate;
      };
      if (isCityMap) this.map1.on('singleclick', this.handleMapClickHandler);
      else this.map.on('singleclick', this.handleMapClickHandler);
      const modalRef = this.modalService.open(
        CategoryPlayerViewModalComponent,
        {
          size: 'md',
          backdrop: 'static',
          keyboard: false,
        },
      );
      modalRef.componentInstance.character_id = this.character_id;
      modalRef.componentInstance.game_id = this.game_id;
      // this.modalRef.componentInstance.charDetails =this.characterDetailsByGame

      modalRef.result.then((res) => {
        if (res) {
          const obj: any = {
            iconname: res.selectedIcon,
            game_id: this.game_id,
            character_id: res.character_id
              ? res.character_id.map((char) => char.character_id)
              : [this.character_id],
            geography:
              this.playerCoordinates[0].toString() +
              ',' +
              this.playerCoordinates[1].toString(),
            color: res.color,
            category: res.category,
            details: res.details,
            mapcode: this.mapCodeDataContainer.map_id,
          };
          if (
            obj.character_id.length > 1 &&
            !obj.character_id.includes(this.character_id)
          )
            obj.character_id.push(this.character_id);
          if (!isCityMap) {
            this.playerViewService
              .addLocationPointInfo(obj)
              .subscribe((data) => {
                this.commonLogicForSharedLocation(data, res, null);
              });
          } else {
            obj.citycode = this.cityCode;
            this.cityDataService
              .cityInsertSharedLocation(obj)
              .subscribe((data) => {
                this.commonLogicForSharedLocation(data, res, this.cityCode);
              });
          }
        }
      });
    } else {
      this.isSideInfo = true;
      if (this.handleMapClickHandler) {
        this.map.un('singleclick', this.handleMapClickHandler);
        this.handleMapClickHandler = null; // Reset the handler reference
      } else {
      }
    }
  }

  commonLogicForSharedLocation(data, res, citycode) {
    if (data) {
      var iconStyle = new Style({
        image: new Icon({
          src: res.selectedIcon,
          scale: 0.15,
        }),
      });
      var feature = new Feature({
        geometry: new Point(this.playerCoordinates),
        draggable: false,
      });
      feature.setStyle(null);
      feature.setStyle(iconStyle);

      // Check if sharedLocationLayer exists, create if not
      if (!this.sharedLocationLayer) {
        this.sharedLocationLayer = new VectorLayer({
          source: new VectorSource(),
          zIndex: 98, // Ensure it's below other layers
        });
        this.map.addLayer(this.sharedLocationLayer);
      }

      if (!citycode) {
        // Add feature to the sharedLocationLayer
        this.sharedLocationLayer.getSource().addFeature(feature);
        this.DataService.getSavedLocationData(this.character_id).subscribe(
          (data) => {
            if (data) {
              this.coordinateService.setNewSavedRecords(data);
            }
          },
        );
      } else {
        // Add feature to the existing cityStaticFeatureLayer
        this.cityStaticFeatureLayer.getSource().addFeature(feature);
        this.cityDataService
          .cityGetSharedLocation(
            this.character_id,
            this.mapCodeDataContainer.map_id,
            citycode,
          )
          .subscribe((sharedLocationRecords: any) => {
            if (sharedLocationRecords.res.length > 0) {
              let data = sharedLocationRecords.res;
              this.coordinateService.setNewSharedLocationCity(data);
            }
          });
      }
    }
    this.isSideInfo = true;
  }
  addStaticPoint(
    coords,
    coordsArr?,
    isRed?,
    token?: string,
    isGameToken?: boolean,
  ) {
    if (!this.layerContentPinLayer) {
      this.layerContentPinLayer = new VectorLayer({
        source: new VectorSource(),
        minZoom: 6,
        zIndex: 99,
      });
      this.map.addLayer(this.layerContentPinLayer);
    } else {
      this.layerContentPinLayer.getSource().clear();
      this.map.removeLayer(this.layerContentPinLayer);
      this.map.addLayer(this.layerContentPinLayer);
    }
    if (!coordsArr) {
      var iconStyle = new Style({
        image: new Icon({
          src: token ? ip + token : '/assets/icons/birth-marker-pin.png',
          scale: isGameToken ? 0.07 : 0.5,
        }),
      });
      var feature = new Feature({
        geometry: new Point(coords),
      });
      feature.setStyle(iconStyle);

      this.layerContentPinLayer.getSource().addFeature(feature);
    } else {
      for (let i of coordsArr) {
        let coords = i as [number, number];

        var iconStyle = new Style({
          image: new Icon({
            src: isRed
              ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzHJHl1-cwaPGeXXEKvW31lMF8NKgB6iH08QXn9dQYfQ&s'
              : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS3xcDxyORHeKEQoRXfC8lq5t0o15aB471W0w&usqp=CAU',
            scale: 0.15,
          }),
        });
        var feature = new Feature({
          geometry: new Point(coords),
        });
        feature.setStyle(iconStyle);
        this.layerContentPinLayer.getSource().addFeature(feature);
      }
    }
  }

  addSingleStaticPoint(
    coords: any,
    iconSrc: string = '/assets/icons/birth-marker-pin.png',
    scale: number = 0.07,
    zIndex: number = 120
  ) {
    // Create layer once
    if (!this.singlePointLayer) {
      this.singlePointLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex,
      });
      this.map.addLayer(this.singlePointLayer);
    } else {
      // clear previous point
      this.singlePointLayer.getSource().clear();
    }

    const pointCoords: [number, number] = [
      Number(coords[0]),
      Number(coords[1]),
    ];

    const feature = new Feature({
      geometry: new Point(pointCoords),
    });

    feature.setStyle(
      new Style({
        image: new Icon({
          src: iconSrc,
          scale,
        }),
      })
    );

    this.singlePointLayer.getSource().addFeature(feature);
  }

  addDifferentContentPin(
    isForceClear: boolean,
    contentObjArr: { coords: [number, number][], idArr: number[], content: ContentData[] },
    isRed: boolean,
    onFeatureClick?: (data: any, feature: Feature) => void,
  ) {

    // Step 1: Create the layer if it doesn't exist
    if (!this.layerContentPinLayer) {
      this.layerContentPinLayer = new VectorLayer({
        source: new VectorSource(),
        minZoom: 6,
        zIndex: 999,
      });
      this.map.addLayer(this.layerContentPinLayer);
    }

    // Step 2: Handle force clear logic
    if (isForceClear && this.layerContentPinLayer) {
      this.layerContentPinLayer.getSource().clear();
      // Optionally reset layer (remove + re-add ensures clean state)
      this.map.removeLayer(this.layerContentPinLayer);
      this.map.addLayer(this.layerContentPinLayer);
    }

    // Step 3: Add new pins from coordsArr
    for (let idx = 0; idx < contentObjArr.coords.length; idx++) {
      const featureData = contentObjArr.content[idx];
      const firstWord = featureData.type?.split(' ')[0];
      const iconName =
        firstWord?.toLowerCase() + '_content_icon.png' ||
        'one_content_icon.png';

      const coords = contentObjArr.coords[idx];
      const iconStyle = new Style({
        image: new Icon({
          src: `assets/icons/${iconName}`,
          scale: 0.12,
        }),
      });

      const feature = new Feature({
        geometry: new Point(coords),
      });
      feature.setStyle(this.contentPinStyleFn(iconName));
      const featureDataConst = {
        ...featureData,
        wp_usage_id: contentObjArr.idArr[idx],
        context: 'map'
      };

      // attach metadata if provided
      feature.set('contentData', featureDataConst);
      this.layerContentPinLayer.getSource().addFeature(feature);
    }

    // wire click handler if callback provided
    if (onFeatureClick) {
      if (this.contentPinsClickKey) {
        unByKey(this.contentPinsClickKey);
      }
      const handler = (evt) => {
        const hit = this.map.forEachFeatureAtPixel(evt.pixel, (feat, layer) =>
          layer === this.layerContentPinLayer ? feat : null,
        );
        if (hit) {
          const data = (hit as any).get && (hit as any).get('contentData');
          onFeatureClick(data, hit as Feature);
        }
      };
      this.contentPinsClickKey = this.map.on('singleclick', handler);
    } else {
      // Default behavior: open modal showing feature data
      if (this.contentPinsClickKey) unByKey(this.contentPinsClickKey);
      const handler = (evt) => {
        const hit = this.map.forEachFeatureAtPixel(evt.pixel, (feat, layer) =>
          layer === this.layerContentPinLayer ? feat : null,
        );
        if (hit) {
          const data = (hit as any).get && (hit as any).get('contentData');
          console.log(data, 'coming here ?');
          const modalRef = this.modalService.open(
            ContentCreatorModalDetailComponent,
            {
              size: 'md',
              modalDialogClass: 'modal-dialog-centered-content',
              windowClass: 'modal-content-center-content',
              backdrop: true,
            },
          );
          (modalRef.componentInstance as any).data = data ?? {};
          (modalRef.componentInstance as any).feature = hit as Feature;
        }
      };
      this.contentPinsClickKey = this.map.on('singleclick', handler);
    }
  }

  private contentPinStyleFn(iconName: string) {
    return (feature: Feature, resolution: number) => {
      const zoom = this.map.getView().getZoom() ?? 0;

      // adjust scale based on zoom
      let scale = 0.08;

      if (zoom >= 5 && zoom < 7) scale = 0.1;
      else if (zoom >= 7 && zoom < 9) scale = 0.12;
      else if (zoom >= 9 && zoom < 11) scale = 0.14;
      else if (zoom >= 11) scale = 0.18;

      return new Style({
        image: new Icon({
          src: `assets/icons/${iconName}`,
          scale,
          anchor: [0.5, 1],
        }),
      });
    };
  }

  addDifferentContentPinCity(
    isForceClear: boolean,
    contentObjArr: { coords: [number, number][], idArr: number[], content: ContentData[] },
    isRed: boolean,
    onFeatureClick?: (data: any, feature: Feature) => void,
  ) {
    // Step 1: Create the layer if it doesn't exist

    if (!this.layerContentCityPinLayer) {
      this.layerContentCityPinLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 99,
      });
      this.map1.addLayer(this.layerContentCityPinLayer);
    }

    // Step 2: Handle force clear logic
    if (isForceClear && this.layerContentCityPinLayer) {
      this.layerContentCityPinLayer.getSource().clear();
      // Optionally reset layer (remove + re-add ensures clean state)
      this.map1.removeLayer(this.layerContentCityPinLayer);
      this.map1.addLayer(this.layerContentCityPinLayer);
    }

    // Step 3: Add new pins from coordsArr
    for (let idx = 0; idx < contentObjArr.coords.length; idx++) {
      const featureData = contentObjArr.content[idx];
      const firstWord = featureData.type?.split(' ')[0];
      const iconName =
        firstWord?.toLowerCase() + '_content_icon.png' ||
        'one_content_icon.png';
      const coords = contentObjArr.coords[idx];
      const iconStyle = new Style({
        image: new Icon({
          src: `assets/icons/${iconName}`,
          scale: 0.12,
        }),
      });

      const feature = new Feature({
        geometry: new Point(coords),
      });
      feature.setStyle(iconStyle);

      if (contentObjArr.content && contentObjArr.content.length > idx) {
        const featureDataConst = {
          ...contentObjArr.content[idx],
          wp_usage_id: contentObjArr.idArr[idx],
          context: 'city'
        };
        feature.set('contentData', featureDataConst);
      }
      this.layerContentCityPinLayer.getSource().addFeature(feature);
    }

    if (onFeatureClick) {
      if (this.contentCityPinsClickKey) {
        unByKey(this.contentCityPinsClickKey);
      }
      const handler = (evt) => {
        const hit = this.map1.forEachFeatureAtPixel(evt.pixel, (feat, layer) =>
          layer === this.layerContentCityPinLayer ? feat : null,
        );
        if (hit) {
          const data = (hit as any).get && (hit as any).get('contentData');
          onFeatureClick(data, hit as Feature);
        }
      };
      this.contentCityPinsClickKey = this.map1.on('singleclick', handler);
    } else {
      if (this.contentCityPinsClickKey) unByKey(this.contentCityPinsClickKey);
      const handler = (evt) => {
        const hit = this.map1.forEachFeatureAtPixel(evt.pixel, (feat, layer) =>
          layer === this.layerContentCityPinLayer ? feat : null,
        );
        if (hit) {
          const data = (hit as any).get && (hit as any).get('contentData');
          const modalRef = this.modalService.open(
            ContentCreatorModalDetailComponent,
            {
              size: 'md',
              modalDialogClass: 'modal-dialog-centered-content',
              windowClass: 'modal-content-center-content',
              backdrop: true,
            },
          );
          (modalRef.componentInstance as any).data = data ?? {};
          (modalRef.componentInstance as any).feature = hit as Feature;
        }
      };
      this.contentCityPinsClickKey = this.map1.on('singleclick', handler);
    }
  }

  /** Round token styles by picture URL, so each picture is drawn once. */
  private birthMarkerCache: Record<string, Style> = {};

  /**
   * The marker for a character's place on the map: the character's picture
   * as a small round token (a full-size upload used to be drawn at half its
   * real size, covering the map), or a pin when there's no picture yet.
   */
  birthMarkerStyle(picture?: string | null): Style {
    if (!picture) {
      return new Style({
        // 512px artwork drawn ~46px tall; its tip (86% down) marks the spot
        image: new Icon({ src: '/assets/icons/birth-marker-pin.png', scale: 0.09, anchor: [0.5, 0.86] }),
      });
    }
    const src = /^(https?:|data:|blob:)/.test(picture) ? picture : ip + picture;
    const cached = this.birthMarkerCache[src];
    if (cached) return cached;

    const size = 44; // on-screen diameter in CSS pixels
    const ring = 3;
    const ratio = Math.max(1, Math.round(window.devicePixelRatio || 1));
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = size * ratio;
    const ctx = canvas.getContext('2d');
    const r = (size * ratio) / 2;
    const drawRing = () => {
      ctx.beginPath();
      ctx.arc(r, r, r - (ring * ratio) / 2, 0, Math.PI * 2);
      ctx.lineWidth = ring * ratio;
      ctx.strokeStyle = '#c9a15c';
      ctx.stroke();
    };
    // placeholder until the picture loads: dark disc with the gold ring
    ctx.beginPath();
    ctx.arc(r, r, r, 0, Math.PI * 2);
    ctx.fillStyle = '#0b1c2e';
    ctx.fill();
    drawRing();

    const img = new Image();
    img.onload = () => {
      const side = Math.min(img.naturalWidth, img.naturalHeight); // centre-crop to a square
      ctx.save();
      ctx.beginPath();
      ctx.arc(r, r, r - ring * ratio, 0, Math.PI * 2);
      ctx.clip();
      ctx.drawImage(
        img,
        (img.naturalWidth - side) / 2, (img.naturalHeight - side) / 2, side, side,
        0, 0, size * ratio, size * ratio,
      );
      ctx.restore();
      drawRing();
      this.map?.render();
      this.map1?.render();
    };
    img.src = src;

    const style = new Style({
      image: new Icon({ img: canvas, imgSize: [canvas.width, canvas.height], scale: 1 / ratio }),
    });
    this.birthMarkerCache[src] = style;
    return style;
  }

  addStaticPointPlayerDetailView(coords: any, token?: string | boolean) {
    const markerStyle = this.birthMarkerStyle(token ? (typeof token === 'string' ? token : this.userProfileUrl) : null);
    if (!this.vectorLayer) {
      this.vectorLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 999,
      });
      this.map.addLayer(this.vectorLayer);
    }
    this.vectorLayer.getSource().clear(); // Clear existing features

    if (Array.isArray(coords) && typeof coords[0] === 'string') {
      coords = coords.map(Number);
    }
    if (typeof coords === 'string') {
      coords = coords.split(',').map(Number);
    }

    let iconSrc = 'assets/images/ac-token-game-large.png';
    if (token) {
      const imgPath = typeof token === 'string' ? token : this.userProfileUrl;
      if (imgPath) {
        iconSrc =
          imgPath.startsWith('http://') ||
            imgPath.startsWith('https://') ||
            imgPath.startsWith('data:') ||
            imgPath.startsWith('blob:')
            ? imgPath
            : ip + imgPath;
      }
    }

    var iconStyle = markerStyle;
    var feature = new Feature({
      geometry: new Point(coords),
    });
    feature.setStyle(iconStyle);
    this.vectorLayer.getSource().addFeature(feature);
  }

  addStaticPointsContentDataCity(coords, coordsArr?, isRed?) {
    if (!this.layerContentCityPinLayer) {
      this.layerContentCityPinLayer = new VectorLayer({
        source: new VectorSource(),
      });
      this.map1.addLayer(this.layerContentCityPinLayer);
    } else {
      this.map1.removeLayer(this.layerContentCityPinLayer);
      this.map1.addLayer(this.layerContentCityPinLayer);
    }
    if (!coordsArr) {
      var iconStyle = new Style({
        image: new Icon({
          src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS3xcDxyORHeKEQoRXfC8lq5t0o15aB471W0w&usqp=CAU',
          scale: 0.15,
        }),
      });
      var feature = new Feature({
        geometry: new Point(coords),
      });
      feature.setStyle(iconStyle);

      this.layerContentCityPinLayer.getSource().addFeature(feature);
    } else {
      for (let i of coordsArr) {
        let coords = i as [number, number];

        var iconStyle = new Style({
          image: new Icon({
            src: isRed
              ? 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTzHJHl1-cwaPGeXXEKvW31lMF8NKgB6iH08QXn9dQYfQ&s'
              : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS3xcDxyORHeKEQoRXfC8lq5t0o15aB471W0w&usqp=CAU',
            scale: 0.15,
          }),
        });
        var feature = new Feature({
          geometry: new Point(coords),
        });
        feature.setStyle(iconStyle);
        this.layerContentCityPinLayer.getSource().addFeature(feature);
      }
    }
  }
  handleMapContentClick(
    addListener,
    isClicked?,
    isStaticPoint?,
    intialLoad?,
    recordToRestore?,
    isCity?: boolean,
  ) {
    // Check if the layerContentPinLayer is already defined
    if (!this.layerContentPinLayer) {
      this.layerContentPinLayer = new VectorLayer({
        source: new VectorSource(),
        minZoom: 6,
        zIndex: 99,
      });
      this.map.addLayer(this.layerContentPinLayer);
    }
    if (intialLoad) {
      var iconStyle = new Style({
        image: new Icon({
          src: '/assets/icons/birth-marker-pin.png',
          scale: 0.07,
        }),
      });
      var feature = new Feature({
        geometry: new Point(intialLoad),
      });
      feature.setStyle(iconStyle);
      this.layerContentPinLayer.getSource().addFeature(feature);
      return;
    }
    this.isSideInfo = false;

    if (addListener) {
      this.handleContentClickHandler = (event) => {
        this.playerCoordinates = event ? event.coordinate : this.universalCords;

        this.isSideInfo = true;
        var iconStyle = new Style({
          image: new Icon({
            src: '/assets/icons/birth-marker-pin.png',
            scale: 0.07,
          }),
        });
        var feature = new Feature({
          geometry: new Point(
            this.playerCoordinates
              ? this.playerCoordinates
              : this.universalCords,
          ),
        });
        feature.setStyle(null);
        feature.setStyle(iconStyle);

        this.layerContentPinLayer.getSource().clear();
        if (!isStaticPoint)
          this.layerContentPinLayer.getSource().addFeature(feature);

        this.coordinateService.setNewCoordinates(
          this.continusCordArray.length > 0
            ? this.continusCordArray[this.continusCordArray.length - 1]
            : this.playerCoordinates,
        );
        this.continusCordArray = [];
        setTimeout(() => {
          if (!isStaticPoint) {
            const source = this.layerContentPinLayer.getSource();
            const features = source.getFeatures();
            if (features.length > 1) {
              source.removeFeature(features[0]);
            }
          }
        }, 0);

        // Handle the click event here
        // For example, open a modal with the coordinates
      };
      if (!this.handlerAdded && isCity)
        this.map1.on('singleclick', this.handleContentClickHandler);
      if (!this.handlerAdded && !isCity)
        this.map.on('singleclick', this.handleContentClickHandler);
      this.handlerAdded = true;

      if (!isClicked) {
        const modal = this.modalService.open(AddContentComponent, {
          size: 'lg',
          backdrop: 'static',
        });
        modal.componentInstance.coords = this.playerCoordinates;
        modal.componentInstance.isModalOpen = true;
        modal.componentInstance.mapCode = this.mapid;
        modal.componentInstance.contentData = recordToRestore;
        if (isCity) modal.componentInstance.cityCode = this.cityCode;
        modal.result.then((result) => {
          if (result) {
            if (!isCity)
              this.coordinateService.setNewContentRecords(result.res);
            else this.coordinateService.setNewCityContentRecords(result.res);
          }
        });
        // Add single-click event listener to the map
      }
    } else {
      if (this.handleContentClickHandler) {
        // Remove single-click event listener from the map
        if (!isCity) {
          this.map.un('singleclick', this.handleContentClickHandler);
          this.map.un('singleclick', this.handleContentClickHandler);
        } else {
          this.map1.un('singleclick', this.handleContentClickHandler);
          this.map1.un('singleclick', this.handleContentClickHandler);
        }
        this.handleContentClickHandler = null; // Reset the handler reference
        this.isSideInfo = true;
      } else {
        this.isSideInfo = true;
      }
    }
  }

  /* City Map */

  addLineOfPathCity(journalEntry) {
    const pointsOfData = journalEntry.movements;
    const features = [];

    if (pointsOfData) {
      // Define the style for the lines

      features.push(
        new Feature({
          geometry: new LineString(pointsOfData),
        }),
      );
    }
    if (!this.layerRedPathHighlightCityLayer) {
      var lineStyle = new Style({
        stroke: new Stroke({
          color: 'red', // Change this to the desired color
          width: 3, // Change this to the desired line width
          lineDash: [15, 15], // Adjust the array values to control the pattern of dashes
        }),
      });
      this.layerRedPathHighlightCityLayer = new VectorLayer({
        source: new VectorSource(),
        style: lineStyle,
        zIndex: 201,
      });
      this.map1?.addLayer(this.layerRedPathHighlightCityLayer);
    }
    this.layerRedPathHighlightCityLayer.getSource().addFeatures(features);
  }

  addLineOfPath(pointsArray) {
    const pointsOfData = pointsArray.movements;
    const features = [];
    if (pointsOfData) {
      features.push(
        new Feature({
          geometry: new LineString(pointsOfData),
        }),
      );
    }
    if (!this.layerRedPathHighlightLayer) {
      var lineStyle = new Style({
        stroke: new Stroke({
          color: 'red', // Change this to the desired color
          width: 3, // Change this to the desired line width
          lineDash: [15, 15], // Adjust the array values to control the pattern of dashes
        }),
      });
      this.layerRedPathHighlightLayer = new VectorLayer({
        source: new VectorSource(),
        style: lineStyle,
        zIndex: 201,
      });
      this.map.addLayer(this.layerRedPathHighlightLayer);
    }
    this.layerRedPathHighlightLayer.getSource().addFeatures(features);
  }

  removeRedLineOfPath(journalEntry) {
    // 1. Get the coordinate data that defines the path to be removed.
    const pointsOfData = journalEntry.movements;

    // 2. Ensure the layer exists and has a source.
    if (
      !this.layerRedPathHighlightLayer ||
      !this.layerRedPathHighlightLayer.getSource()
    ) {
      console.warn('The vector layer for path highlights does not exist.');
      return;
    }

    const source = this.layerRedPathHighlightLayer.getSource();

    // A helper function to compare two coordinate arrays (LineString geometries)
    // Simple array equality check is often sufficient for coordinates retrieved from the same source data.
    const isGeometryEqual = (geom1, geom2) => {
      if (!geom1 || !geom2 || geom1.length !== geom2.length) {
        return false;
      }
      for (let i = 0; i < geom1.length; i++) {
        // Assuming coordinates are arrays [x, y]
        if (geom1[i][0] !== geom2[i][0] || geom1[i][1] !== geom2[i][1]) {
          return false;
        }
      }
      return true;
    };

    // 3. Iterate through all features currently in the layer source.
    source.getFeatures().forEach((feature) => {
      const geometry: any = feature.getGeometry();

      // Check if the feature is a LineString.
      if (geometry && geometry.getType() === 'LineString') {
        const featureCoords = geometry.getCoordinates();

        // 4. Compare the feature's coordinates with the path data to be removed.
        if (isGeometryEqual(featureCoords, pointsOfData)) {
          // 5. If they match, remove the feature from the source.
          source.removeFeature(feature);
          // Note: You can break the loop here if you are sure there is only one matching feature.
        }
      }
    });
  }
  removeRedLineOfPathCity(journalEntry) {
    // 1. Get the coordinate data that defines the path to be removed.
    const pointsOfData = journalEntry.movements;

    // 2. Ensure the layer exists and has a source.
    if (
      !this.layerRedPathHighlightCityLayer ||
      !this.layerRedPathHighlightCityLayer.getSource()
    ) {
      console.warn('The vector layer for path highlights does not exist.');
      return;
    }

    const source = this.layerRedPathHighlightCityLayer.getSource();

    // A helper function to compare two coordinate arrays (LineString geometries)
    // Simple array equality check is often sufficient for coordinates retrieved from the same source data.
    const isGeometryEqual = (geom1, geom2) => {
      if (!geom1 || !geom2 || geom1.length !== geom2.length) {
        return false;
      }
      for (let i = 0; i < geom1.length; i++) {
        // Assuming coordinates are arrays [x, y]
        if (geom1[i][0] !== geom2[i][0] || geom1[i][1] !== geom2[i][1]) {
          return false;
        }
      }
      return true;
    };

    // 3. Iterate through all features currently in the layer source.
    source.getFeatures().forEach((feature) => {
      const geometry: any = feature.getGeometry();

      // Check if the feature is a LineString.
      if (geometry && geometry.getType() === 'LineString') {
        const featureCoords = geometry.getCoordinates();

        // 4. Compare the feature's coordinates with the path data to be removed.
        if (isGeometryEqual(featureCoords, pointsOfData)) {
          // 5. If they match, remove the feature from the source.
          source.removeFeature(feature);
          // Note: You can break the loop here if you are sure there is only one matching feature.
        }
      }
    });
  }

  addConstantMovmentLine(cordsArr, isRemoveLastLayer, timeStamp?) {
    var layers = this.map.getLayers().getArray();

    // if(isRemoveLastLayer)  this.map.removeLayer(layers[layers.length-1]);

    const features = [];
    const cordsLineArr = [];
    for (let everyCord of cordsArr) {
      let pointsOfData = everyCord.movements;
      if (pointsOfData) {
        cordsLineArr.push(pointsOfData);
        // Define the style for the lines
        features.push(
          new Feature({
            geometry: new LineString(pointsOfData),
          }),
        );
      }
    }
    // this.setFilter(cordsLineArr);
    // this.setFilter(cordsLineArr.flat())

    if (this.layerConstLinesLayer) {
      this.layerConstLinesLayer.getSource().clear();
      this.map.removeLayer(this.layerConstLinesLayer);
      this.map.addLayer(this.layerConstLinesLayer);
    } else {
      var lineStyle = new Style({
        stroke: new Stroke({
          color: 'orange', // Change this to the desired color
          width: 3, // Change this to the desired line width
          lineDash: [15, 15], // Adjust the array values to control the pattern of dashes
        }),
      });
      this.layerConstLinesLayer = new VectorLayer({
        source: new VectorSource(),
        style: lineStyle,
        zIndex: 200,
      });
      this.map.addLayer(this.layerConstLinesLayer);
    }
    this.layerConstLinesLayer.getSource().addFeatures(features);
  }

  addCityConstantLine(cordsArr, isRemoveLastLayer, timeStamp?) {
    // if(isRemoveLastLayer)  this.map.removeLayer(layers[layers.length-1]);
    const features = [];

    for (let everyCord of cordsArr) {
      let pointsOfData = everyCord.movements;
      if (pointsOfData) {
        // Define the style for the lines
        features.push(
          new Feature({
            geometry: new LineString(pointsOfData),
          }),
        );
      }
    }
    if (this.layerConstCityLinesLayer) {
      //
      this.layerConstCityLinesLayer.getSource().clear();
    } else {
      var lineStyle = new Style({
        stroke: new Stroke({
          color: 'blue', // Change this to the desired color
          width: 3, // Change this to the desired line width
          lineDash: [15, 15], // Adjust the array values to control the pattern of dashes
        }),
      });
      this.layerConstCityLinesLayer = new VectorLayer({
        source: new VectorSource(),
        style: lineStyle,
        zIndex: 200,
      });
      this.map1.addLayer(this.layerConstCityLinesLayer);
    }
    this.layerConstCityLinesLayer.getSource().addFeatures(features);
  }

  removeOldMap(): void {
    if (this.layerConstLinesLayer) {
      this.layerConstLinesLayer.getSource().clear();
      this.map.removeLayer(this.layerConstLinesLayer);
    }
    if (this.singlePointLayer) {
      this.singlePointLayer.getSource().clear();
      this.map.removeLayer(this.singlePointLayer);
      this.singlePointLayer = null;
    }
    if (this.mainDrawInteraction) {
      this.map.removeInteraction(this.mainDrawInteraction);
    }
    if (this.playerModifyInteraction) {
      this.map.removeInteraction(this.playerModifyInteraction);
    }
    this.removeWorldDragTools();
    if (this.birthLocationLayer) {
      this.map.removeLayer(this.birthLocationLayer);
    }

    if (this.sharedLocationLayer) {
      this.sharedLocationLayer.getSource().clear();
    }
    if (this.playerToGameLocationLayer) {
      this.playerToGameLocationLayer.getSource().clear();
    }
    if (this.layerRedPathHighlightLayer) {
      this.layerRedPathHighlightLayer.getSource().clear();
      this.map.removeLayer(this.layerRedPathHighlightLayer);
    }
    if (this.layerContentPinLayer) {
      this.layerContentPinLayer.getSource().clear();
    }
    // Remove all layers from the map
    this.map.getLayers().forEach((layer) => {
      this.map.removeLayer(layer);
    });
    if (this.vectorLayer) {
      this.vectorLayer.getSource().clear();
      // Clear the vector layer source
      // this.vectorLayer.getSource().refresh();
      this.map.removeLayer(this.vectorLayer);
      this.vectorLayer = null;
    }
    this.layerlist.forEach((lyr: any) => {
      if (lyr.crop) {
        lyr['crop'].set('active', false);
        lyr['crop'] = null;
        lyr['feature'] = null;
        const mapLayer: any = this.map
          .getLayers()
          .getArray()
          .find((ml: any) => ml.get('name') === lyr.name);
        if (mapLayer) {
          mapLayer.removeFilter(lyr.crop);
        }
      }

      // Optional: clear the feature reference
      if (lyr.feature) {
        lyr.feature = null;
      }
    });
    // Remove modify interaction
    // Clear the canvas associated with the map viewport
    const canvas = this.map.getViewport().querySelector('canvas');
    canvas?.remove();
    if (canvas) this.continusCordArray = [];
    this.map.removeLayer(this.burgLayer);

    this.map.getLayers().forEach((lyr) => {
      lyr.setVisible(false);
    });
    this.loadDataSubscription?.unsubscribe();
    this.viewparam = null;
    this.character_id = null;
    this.getpartybygame = '';
    this.map_genre = null;
    this.game_system = null;
    this.navigateToCityFlag = true;
    if (this.layerContentPinLayerInstance) {
      this.layerContentPinLayerInstance['feature'] = null;
      (this.layerContentPinLayer as any)?.removeFilter(
        this.layerContentPinLayerInstance['crop'],
      );
      this.layerContentPinLayerInstance['crop'] = null;
      this.layerContentPinLayer = null;
    }

    this.playerFeature = null;
    this.playerCurrentLocationCords = [];
    // if (canvas) {
    //     const context = canvas.getContext('2d');
    //     context.clearRect(0, 0, canvas.width, canvas.height);
    // }

    // Remove the map from its parent element
    // const mapElement = this.map.getTargetElement();
    // if (mapElement && mapElement.parentNode) {
    //     mapElement.parentNode.removeChild(mapElement);
    // }
    // Reset the map instance
    // this.map = null;
    // Reset other variables if needed
    // For example:
    // this.wmslayerList = [];
  }

  cityBackClick() {
    // this.setFilter(this.continusCordArray[this.continusCordArray.length - 1]);
    // this.continusCordArray = [];
  }

  handleAddCharacterMapClick() {
    this.map.on('click', (event) => { });
  }

  cityMapBirthLocation(token?: string, isCreate?: boolean) {
    const markerStyle = this.birthMarkerStyle(!isCreate ? (token || this.userProfileUrl) : null);
    if (!this.cityFeatureVectorLayer) {
      this.cityFeatureVectorLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 99,
      });
      this.map1.addLayer(this.cityFeatureVectorLayer);
    }
    if (this.cityDrawInteraction) {
      this.map1.removeInteraction(this.cityDrawInteraction);
    }

    let tokenSrc = 'assets/images/ac-token-game-large.png';
    const imgPath = token || this.userProfileUrl;
    if (imgPath && !isCreate) {
      tokenSrc =
        imgPath.startsWith('http://') ||
          imgPath.startsWith('https://') ||
          imgPath.startsWith('data:') ||
          imgPath.startsWith('blob:')
          ? imgPath
          : ip + imgPath;
    }

    const existingFeatures = this.cityFeatureVectorLayer.getSource()?.getFeatures();
    if (existingFeatures && existingFeatures.length > 0) {
      existingFeatures.forEach((feat) => {
        feat.setStyle(
          markerStyle,
        );
      });
    }

    this.cityDrawInteraction = new Draw({
      source: this.cityFeatureVectorLayer.getSource(),
      type: 'Point',
      // The marker follows the mouse until a spot is chosen, so you can see
      // where it will land; once placed, only the placed marker shows (click
      // again to move it).
      style: () => (this.cityFeatureVectorLayer.getSource().getFeatures().length ? null : markerStyle),
    });
    this.cityDrawInteraction.on('drawstart', (event) => {
      const feature = event.feature;
      feature.setStyle(
        markerStyle,
      );
    });
    this.cityDrawInteraction.on('drawend', (event) => {
      if (this.cityFeatureVectorLayer) {
        this.cityFeatureVectorLayer.getSource().clear();
      }

      this.cityMapService.setCityMapCoordinates(
        event.feature.getGeometry().getCoordinates(),
      );
      const feature = event.feature;

      feature.setStyle(
        markerStyle,
      );
    });
    this.map1.addInteraction(this.cityDrawInteraction);
  }

  addCityStaticPoint(coords, token?: string | boolean) {

    if (!this.cityFeatureVectorLayer) {
      this.cityFeatureVectorLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 999,
      });
      this.map1.addLayer(this.cityFeatureVectorLayer);
    }

    if (Array.isArray(coords) && typeof coords[0] === 'string') {
      coords = coords.map(Number);
    }
    if (typeof coords == 'string') {
      coords = coords.split(',').map(Number);
    }
    var feature = new Feature({
      geometry: new Point(coords),
    });

    const featureCoords = (feature.getGeometry() as Point).getCoordinates() as [
      number,
      number,
    ];
    const isInside = this.isPointInsidePolygon(
      featureCoords,
      this.cityLandCoordinates,
    );

    this.coordinateService.setAtCityBoundary(!isInside);

    feature.setStyle(this.birthMarkerStyle(token ? this.userProfileUrl : null));
    this.cityFeatureVectorLayer.getSource().addFeature(feature);
    const extent = feature.getGeometry().getExtent();
    this.map1?.getView().fit(extent, {
      duration: 1000,
      padding: [50, 50, 50, 50],
      maxZoom: DEFAULT_ZOOM,
    });
  }

  intializeMainMapBirthLocation(token?: string) {
    const markerStyle = this.birthMarkerStyle(token || null);
    // 1) ensure vectorLayer exists & is empty

    this.birthLocationLayer = null;
    if (!this.birthLocationLayer) {
      this.birthLocationLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 999,
      });
      this.map.addLayer(this.birthLocationLayer);
    } else {
      this.birthLocationLayer.getSource().clear();
    }
    if (this.mainDrawInteraction) {
      this.map.removeInteraction(this.mainDrawInteraction);
    }

    let iconSrc = 'assets/images/ac-token-game-large.png';
    if (token) {
      iconSrc =
        token.startsWith('http://') ||
          token.startsWith('https://') ||
          token.startsWith('data:') ||
          token.startsWith('blob:')
          ? token
          : ip + token;
    }

    // Update style of any already placed birth location feature
    const existingFeatures = this.birthLocationLayer.getSource()?.getFeatures();
    if (existingFeatures && existingFeatures.length > 0) {
      existingFeatures.forEach((feat) => {
        feat.setStyle(
          markerStyle,
        );
      });
    }

    // 2) create a new Draw interaction
    this.mainDrawInteraction = new Draw({
      source: this.birthLocationLayer.getSource(),
      type: 'Point',
      // The marker follows the mouse until a spot is chosen, so you can see
      // where it will land; once placed, only the placed marker shows (click
      // again to move it).
      style: () => (this.birthLocationLayer.getSource().getFeatures().length ? null : markerStyle),
    });

    // 3) restyle the feature as soon as drawing starts
    this.mainDrawInteraction.on('drawstart', (evt) => {
      const feat = evt.feature;
      feat.setStyle(
        markerStyle,
      );
    });

    // 4) on drawend: clear old marker, set coords, finalize style, then remove interaction
    this.mainDrawInteraction.on('drawend', (evt) => {
      // clear any previous
      this.birthLocationLayer?.getSource()?.clear();
      if (this.cityFeatureVectorLayer?.getSource()?.getFeatures().length > 0) {
        this.cityFeatureVectorLayer.getSource().clear();
        this.cityMapService.setCityMapVisiblity({ visible: false, code: null });
      } else if (this.map1.getLayers().getLength() > 1) {
        this.cityMapService.setCityMapVisiblity({ visible: false, code: null });
      }

      // grab the coords
      const coords = (evt.feature.getGeometry() as Point).getCoordinates();
      // emit out to whatever service you use for main map
      this.coordinateService.setNewCoordinates(coords);

      // restyle the placed feature (smaller if no token)
      evt.feature.setStyle(
        markerStyle,
      );

      // remove the draw interaction once placed
      //sthis.map.removeInteraction(this.mainDrawInteraction);
    });

    // 5) finally, add it to the map
    this.map.addInteraction(this.mainDrawInteraction);
  }

  unbindSingleClick() {
    unByKey(this.unbindSingleClickKey);
  }
  bindSingleClick() {
    this.unbindSingleClickKey = this.map.on(
      'singleclick',
      this.handleMapClickHandlerSingleClick.bind(this),
    );
  }

  zoomIn() {
    const view = this.map.getView();
    const zoom = view.getZoom();
    view.setZoom(zoom + 1);
  }
  zoomOut() {
    const view = this.map.getView();
    const zoom = view.getZoom();
    view.setZoom(zoom - 1);
  }

  zoomInCity() {
    const view = this.map1.getView();
    const zoom = view.getZoom();
    view.setZoom(zoom + 1);
  }
  zoomOutCity() {
    const view = this.map1.getView();
    const zoom = view.getZoom();
    view.setZoom(zoom - 1);
  }

  zoomToExtent(type?: string, playerCreateMode?: string, zoomForce?: number) {
    if (type === 'city-map') {
      if (this.cityCode && this.map1) {
        const getExtent = this.cityFeatureVectorLayer.getSource().getExtent();
        this.map1.getView().fit(getExtent, {
          maxZoom: 10, // Set your desired max zoom level
          duration: 500, // Optional: smooth animation
        });
      }
    } else {
      let getExtent = null;
      if (playerCreateMode && playerCreateMode === 'create') {
        getExtent = this.birthLocationLayer.getSource().getExtent();
        this.map.getView().fit(getExtent, {
          maxZoom: 10, // Set your desired max zoom level
          duration: 500, // Optional: smooth animation
        });
      } else {
        getExtent = this.vectorLayer.getSource().getExtent();
        this.map.getView().fit(getExtent, {
          maxZoom: zoomForce || 10, // Set your desired max zoom level
          duration: 500, // Optional: smooth animation
        });
      }
    }
  }

  createAndAddFeatureToLayer(iconSrc: string, coordinateStr: string) {
    if (!coordinateStr) return;
    if (!this.sharedLocationLayer) {
      this.sharedLocationLayer = new VectorLayer({
        source: new VectorSource(),
        zIndex: 99,
      });
      this.map.addLayer(this.sharedLocationLayer);
    }

    const parts = coordinateStr.split(',').map(Number);
    if (parts.length !== 2 || parts.some(isNaN)) {
      console.warn('Invalid coordinate string:', coordinateStr);
      return;
    }

    const [lon, lat] = parts;

    const iconStyle = new Style({
      image: new Icon({
        src: iconSrc,
        scale: 0.35,
      }),
    });

    const feature = new Feature({
      geometry: new Point([lon, lat]),
      draggable: false,
    });

    feature.setStyle(null);
    feature.setStyle(iconStyle);

    this.sharedLocationLayer.getSource().addFeature(feature);
  }

  zoomToRedirectCoordsCity(redirect_coords: string) {
    if (!redirect_coords) return;

    const parts = redirect_coords.split(',').map(Number);
    if (parts.length !== 2 || parts.some(isNaN)) {
      console.warn('Invalid coordinate string:', redirect_coords);
      return;
    }
    const [lon, lat] = parts;
    setTimeout(() => {
      this.map1.getView().setCenter([lon, lat]);
      this.map1.getView().setZoom(18);
    }, 1000);
  }

  zoomToRedirectCoordsMain(redirect_coords: string) {
    if (!redirect_coords) return;

    const parts = redirect_coords.split(',').map(Number);
    if (parts.length !== 2 || parts.some(isNaN)) {
      console.warn('Invalid coordinate string:', redirect_coords);
      return;
    }
    const [lon, lat] = parts;
    setTimeout(() => {
      this.map.getView().setCenter([lon, lat]);
      this.map.getView().setZoom(18);
    }, 1000);
  }
}

